// // /**
// //  * FILE: assets/custom-metafield-search.js
// //  *
// //  * Unified custom product search (title + metafields + SKU), replacing
// //  * Shopify's native predictive search dropdown (hidden via CSS in
// //  * custom-metafield-search.css).
// //  *
// //  * DATA SOURCE: collections.all proved unreliable on this store's large
// //  * catalog (25,000+ products). Instead, this fetches the list of all
// //  * collection handles (templates/page.search-index.liquid), then fetches
// //  * each collection's own product feed (templates/collection.feed.liquid,
// //  * via /collections/<handle>?view=feed&sort_by=title-ascending) and
// //  * merges/dedupes by product ID. The sort_by=title-ascending part is
// //  * required — without it, pagination on very large collections silently
// //  * drops some products between page boundaries.
// //  *
// //  * PROGRESSIVE RESULTS: Collections are fetched in small parallel
// //  * batches. Instead of waiting for every collection to finish before
// //  * showing anything, the search re-runs and updates the visible results
// //  * after EACH batch completes — so results appear quickly and get more
// //  * complete as loading continues, with a "Still loading…" note shown
// //  * until everything has arrived.
// //  *
// //  * SETUP:
// //  * 1. assets/custom-metafield-search.js (this file)
// //  * 2. assets/custom-metafield-search.css
// //  * 3. templates/page.search-index.liquid (collection handle list; assign
// //  *    as a Page's Theme template)
// //  * 4. templates/collection.feed.liquid (per-collection product feed; no
// //  *    Admin assignment needed, works via ?view=feed)
// //  * 5. templates/page.search-results.liquid + a "Search Results" Page
// //  *    using it, if the full results page is enabled
// //  * 6. In theme.liquid (just before </body>):
// //  *      <script src="{{ 'custom-metafield-search.js' | asset_url }}" defer="defer"></script>
// //  *      {{ 'custom-metafield-search.css' | asset_url | stylesheet_tag }}
// //  */
// // (function () {
// //   "use strict";

// //   var FEED_URL = "/pages/search-index";
// //   var MIN_QUERY_LENGTH = 3;
// //   var MAX_RESULTS = 3;
// //   var DEBOUNCE_MS = 200;
// //   var COLLECTION_BATCH_SIZE = 3;

// //   var METAFIELD_LABELS = {
// //     sku: "SKU",
// //     instrumentation: "Instrumentation",
// //     composer: "Composer",
// //     arranger: "Arranger",
// //     contents_list: "Contents",
// //     isbn13: "ISBN13",
// //     upc: "UPC",
// //     supplier_code: "Supplier Code",
// //     label: "Label",
// //     tension: "Tension",
// //     colour: "Colour",
// //     size: "Size",
// //     made_in: "Made In"
// //   };
// //   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

// //   /* ---------------------------------------------------------------
// //    * Shared, progressively-growing product index for THIS page load.
// //    * ------------------------------------------------------------- */
// //   var indexState = {
// //     products: [], // grows as batches complete
// //     byId: {},
// //     complete: false,
// //     startedAt: null,
// //     listeners: [] // functions called after every batch update
// //   };

// //   function notifyProgress() {
// //     indexState.listeners.forEach(function (fn) {
// //       try {
// //         fn(indexState.products, indexState.complete);
// //       } catch (e) {
// //         /* ignore listener errors */
// //       }
// //     });
// //   }

// //   function onIndexProgress(fn) {
// //     indexState.listeners.push(fn);
// //     return function unsubscribe() {
// //       var i = indexState.listeners.indexOf(fn);
// //       if (i !== -1) indexState.listeners.splice(i, 1);
// //     };
// //   }

// //   function fetchJson(url) {
// //     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
// //     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
// //       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
// //       return res.json();
// //     });
// //   }

// //   function fetchAllCollectionHandles() {
// //     return fetchJson(FEED_URL + "?page=1").then(function (first) {
// //       var handles = (first.collections || []).slice();
// //       var totalPages = first.pages || 1;
// //       if (totalPages <= 1) return handles;

// //       var pagePromises = [];
// //       for (var p = 3; p <= totalPages; p++) {
// //         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
// //       }
// //       return Promise.all(pagePromises).then(function (rest) {
// //         rest.forEach(function (pageData) {
// //           handles = handles.concat(pageData.collections || []);
// //         });
// //         return handles;
// //       });
// //     });
// //   }

// //   var buildPromise = null;

// //   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
// //   // This alone gives broad coverage quickly, including the first 250
// //   // products of even the largest collection. Phase 2 then fills in any
// //   // remaining pages, processing smaller leftovers first and the
// //   // biggest collection's remaining pages last, so early progress
// //   // updates aren't blocked waiting on the whole catalog.
// //   function startBuildingIndex() {
// //     if (buildPromise) return buildPromise;

// //     indexState.startedAt = Date.now();
// //     console.log("[CMS] building product index (two-phase, progressive)...");

// //     buildPromise = (async function () {
// //       try {
// //         var handles = await fetchAllCollectionHandles();
// //         console.log("[CMS] found", handles.length, "collections");

// //         function addProducts(products) {
// //           products.forEach(function (p) {
// //             if (!indexState.byId[p.id]) {
// //               indexState.byId[p.id] = p;
// //               indexState.products.push(p);
// //             }
// //           });
// //         }

// //         // ---- Phase 1: page 1 of every collection ----
// //         var needsMore = []; // { handle, pages }
// //         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
// //           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
// //           var batchResults = await Promise.all(
// //             batch.map(function (handle) {
// //               var base =
// //                 "/collections/" +
// //                 encodeURIComponent(handle) +
// //                 "?view=feed&sort_by=title-ascending";
// //               return fetchJson(base + "&page=1")
// //                 .then(function (data) {
// //                   return { handle: handle, data: data };
// //                 })
// //                 .catch(function (err) {
// //                   console.error("[CMS] failed fetching", handle, "page 1", err);
// //                   return null;
// //                 });
// //             })
// //           );

// //           batchResults.forEach(function (result) {
// //             if (!result) return;
// //             addProducts(result.data.products || []);
// //             var totalPages = result.data.pages || 1;
// //             if (totalPages > 1) {
// //               needsMore.push({ handle: result.handle, pages: totalPages });
// //             }
// //           });

// //           notifyProgress(); // fast, broad progress after each small batch
// //         }

// //         console.log(
// //           "[CMS] phase 1 done:",
// //           indexState.products.length,
// //           "products from page-1 of every collection.",
// //           needsMore.length,
// //           "collections have more pages."
// //         );

// //         // ---- Phase 2: remaining pages, smallest leftovers first ----
// //         needsMore.sort(function (a, b) {
// //           return a.pages - b.pages;
// //         });

// //         for (var j = 0; j < needsMore.length; j++) {
// //           var entry = needsMore[j];
// //           var base2 =
// //             "/collections/" +
// //             encodeURIComponent(entry.handle) +
// //             "?view=feed&sort_by=title-ascending";

// //           var remainingPagePromises = [];
// //           for (var p = 3; p <= entry.pages; p++) {
// //             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
// //           }

// //           try {
// //             var pagesData = await Promise.all(remainingPagePromises);
// //             pagesData.forEach(function (pageData) {
// //               addProducts(pageData.products || []);
// //             });
// //           } catch (err) {
// //             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
// //           }

// //           notifyProgress(); // update after each collection's remaining pages finish
// //         }

// //         indexState.complete = true;
// //         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
// //         console.log(
// //           "[CMS] index complete:",
// //           indexState.products.length,
// //           "products in",
// //           seconds + "s"
// //         );
// //         notifyProgress();
// //       } catch (err) {
// //         console.error("[CMS] building index FAILED:", err);
// //       }
// //     })();

// //     return buildPromise;
// //   }

// //   function normalise(str) {
// //     return (str || "").toString().toLowerCase().trim();
// //   }

// //   function alnumOnly(str) {
// //     return normalise(str).replace(/[^a-z0-9]/g, "");
// //   }

// //   function matchProduct(product, q) {
// //     var title = normalise(product.title);
// //     if (title.indexOf(q) !== -1) {
// //       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
// //     }

// //     if (product.sku) {
// //       var skuNorm = alnumOnly(product.sku);
// //       var qNorm = alnumOnly(q);
// //       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
// //         return { field: "sku", score: 90 };
// //       }
// //     }

// //     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
// //       var key = METAFIELD_KEYS[i];
// //       if (key === "sku") continue;
// //       var val = normalise(product[key]);
// //       if (val && val.indexOf(q) !== -1) {
// //         return { field: key, score: 60 };
// //       }
// //     }
// //     return null;
// //   }

// //   function searchProducts(query, products, limit) {
// //     var q = normalise(query);
// //     if (q.length < MIN_QUERY_LENGTH) return [];

// //     var results = [];
// //     for (var i = 0; i < products.length; i++) {
// //       var match = matchProduct(products[i], q);
// //       if (match) {
// //         results.push({ product: products[i], matchedField: match.field, score: match.score });
// //       }
// //     }

// //     results.sort(function (a, b) {
// //       return b.score - a.score;
// //     });

// //     return results.slice(0, limit || MAX_RESULTS);
// //   }

// //   function escapeHtml(str) {
// //     var div = document.createElement("div");
// //     div.textContent = str == null ? "" : String(str);
// //     return div.innerHTML;
// //   }

// //   function renderDropdown(container, results, query, stillLoading) {
// //     if (!results.length) {
// //       if (stillLoading) {
// //         container.innerHTML = '<div class="cms-loading">Searching&hellip;</div>';
// //       } else {
// //         container.innerHTML =
// //           '<div class="cms-no-results">No results for &ldquo;' +
// //           escapeHtml(query) +
// //           "&rdquo;</div>" +
// //           '<button type="button" class="cms-view-all-btn">View all results</button>';
// //       }
// //       container.hidden = false;
// //       return;
// //     }

// //     var html = '<ul class="cms-results-list" role="listbox">';
// //     results.forEach(function (r) {
// //       var p = r.product;
// //       var matchLine = "";
// //       if (r.matchedField) {
// //         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
// //         matchLine =
// //           '<span class="cms-result-match">' +
// //           escapeHtml(label) +
// //           ": " +
// //           escapeHtml(p[r.matchedField]) +
// //           "</span>";
// //       }
// //       html +=
// //         '<li class="cms-result-item" role="option">' +
// //         '<a href="' +
// //         escapeHtml(p.url) +
// //         '" class="cms-result-link">' +
// //         (p.image
// //           ? '<img class="cms-result-image" src="' +
// //             escapeHtml(p.image) +
// //             '" alt="" loading="lazy" width="48" height="48">'
// //           : '<span class="cms-result-image cms-result-image--empty"></span>') +
// //         '<span class="cms-result-text">' +
// //         '<span class="cms-result-title">' +
// //         escapeHtml(p.title) +
// //         "</span>" +
// //         matchLine +
// //         "</span>" +
// //         "</a>" +
// //         "</li>";
// //     });
// //     html += "</ul>";

// //     html +=
// //       '<button type="button" class="cms-view-all-btn">View all results</button>';

// //     container.innerHTML = html;
// //     container.hidden = false;
// //   }

// //   function debounce(fn, wait) {
// //     var timer = null;
// //     return function () {
// //       var args = arguments;
// //       var ctx = this;
// //       clearTimeout(timer);
// //       timer = setTimeout(function () {
// //         fn.apply(ctx, args);
// //       }, wait);
// //     };
// //   }

// //   var sharedContainer = null;

// //   function ensureContainer(input) {
// //     if (!sharedContainer) {
// //       sharedContainer = document.createElement("div");
// //       sharedContainer.id = "cms-metafield-results-shared";
// //       sharedContainer.className = "cms-metafield-results";
// //       sharedContainer.hidden = true;
// //     }
// //     var form = input.closest("form");
// //     var anchor = form || input;
// //     if (sharedContainer.previousElementSibling !== anchor) {
// //       anchor.insertAdjacentElement("afterend", sharedContainer);
// //     }
// //     return sharedContainer;
// //   }

// //   var activeUnsubscribe = null;

// //   function runDropdownSearch(input, container) {
// //     var query = input.value;

// //     if (activeUnsubscribe) {
// //       activeUnsubscribe();
// //       activeUnsubscribe = null;
// //     }

// //     if (normalise(query).length < MIN_QUERY_LENGTH) {
// //       container.hidden = true;
// //       container.innerHTML = "";
// //       return;
// //     }

// //     // Show a loading state immediately.
// //     container.innerHTML = '<div class="cms-loading">Searching&hellip;</div>';
// //     container.hidden = false;

// //     startBuildingIndex();

// //     function renderNow() {
// //       // Always read the CURRENT input value, in case the user kept
// //       // typing while a batch was loading — avoids showing stale results.
// //       var currentQuery = input.value;
// //       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
// //       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
// //       renderDropdown(container, results, currentQuery, !indexState.complete);
// //     }

// //     renderNow(); // render with whatever's loaded so far, immediately
// //     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
// //   }

// //   var handleInputDebounced = debounce(function (input, container) {
// //     runDropdownSearch(input, container);
// //   }, DEBOUNCE_MS);

// //   function getRealTarget(e) {
// //     if (typeof e.composedPath === "function") {
// //       var path = e.composedPath();
// //       if (path && path.length) return path[0];
// //     }
// //     return e.target;
// //   }

// //   function init() {
// //     console.log("[CMS] custom-metafield-search.js initialised");

// //     document.addEventListener(
// //       "focus",
// //       function (e) {
// //         var target = getRealTarget(e);
// //         if (target && target.classList && target.classList.contains("js-search-input")) {
// //           startBuildingIndex(); // warm up the index as soon as the box is focused
// //         }
// //       },
// //       true
// //     );

// //     document.addEventListener("input", function (e) {
// //       var input = getRealTarget(e);
// //       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
// //       var container = ensureContainer(input);
// //       handleInputDebounced(input, container);
// //     });

// //     document.addEventListener("click", function (e) {
// //       var target = getRealTarget(e);

// //       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
// //         var form = sharedContainer && sharedContainer.previousElementSibling;
// //         if (form && form.tagName === "FORM") {
// //           if (typeof form.requestSubmit === "function") {
// //             form.requestSubmit();
// //           } else {
// //             form.submit();
// //           }
// //         }
// //         return;
// //       }

// //       if (
// //         sharedContainer &&
// //         !sharedContainer.hidden &&
// //         target !== sharedContainer &&
// //         !sharedContainer.contains(target) &&
// //         !(target && target.classList && target.classList.contains("js-search-input"))
// //       ) {
// //         sharedContainer.hidden = true;
// //       }
// //     });

// //     // Enter / form submit: intentionally left as the theme's native/
// //     // default behaviour (not intercepted). Only the typing dropdown
// //     // above is custom.
// //   }

// //   if (document.readyState === "loading") {
// //     document.addEventListener("DOMContentLoaded", init);
// //   } else {
// //     init();
// //   }
// // })();


// /**
//  * FILE: assets/custom-metafield-search.js
//  *
//  * Unified custom product search (title + metafields + SKU), replacing
//  * Shopify's native predictive search dropdown (hidden via CSS in
//  * custom-metafield-search.css).
//  *
//  * DATA SOURCE: collections.all proved unreliable on this store's large
//  * catalog (25,000+ products). Instead, this fetches the list of all
//  * collection handles (templates/page.search-index.liquid), then fetches
//  * each collection's own product feed (templates/collection.feed.liquid,
//  * via /collections/<handle>?view=feed&sort_by=title-ascending) and
//  * merges/dedupes by product ID. The sort_by=title-ascending part is
//  * required — without it, pagination on very large collections silently
//  * drops some products between page boundaries.
//  *
//  * PROGRESSIVE RESULTS: Collections are fetched in small parallel
//  * batches. Instead of waiting for every collection to finish before
//  * showing anything, the search re-runs and updates the visible results
//  * after EACH batch completes — so results appear quickly and get more
//  * complete as loading continues, with a "Still loading…" note shown
//  * until everything has arrived.
//  *
//  * SETUP:
//  * 1. assets/custom-metafield-search.js (this file)
//  * 2. assets/custom-metafield-search.css
//  * 3. templates/page.search-index.liquid (collection handle list; assign
//  *    as a Page's Theme template)
//  * 4. templates/collection.feed.liquid (per-collection product feed; no
//  *    Admin assignment needed, works via ?view=feed)
//  * 5. templates/page.search-results.liquid + a "Search Results" Page
//  *    using it, if the full results page is enabled
//  * 6. In theme.liquid (just before </body>):
//  *      <script src="{{ 'custom-metafield-search.js' | asset_url }}" defer="defer"></script>
//  *      {{ 'custom-metafield-search.css' | asset_url | stylesheet_tag }}
//  */
// (function () {
//   "use strict";

//   var FEED_URL = "/pages/search-index";
//   var MIN_QUERY_LENGTH = 2;
//   var MAX_RESULTS = 3;
//   var DEBOUNCE_MS = 200;
//   var COLLECTION_BATCH_SIZE = 5;

//   var METAFIELD_LABELS = {
//     sku: "SKU",
//     instrumentation: "Instrumentation",
//     composer: "Composer",
//     arranger: "Arranger",
//     contents_list: "Contents",
//     isbn13: "ISBN13",
//     upc: "UPC",
//     supplier_code: "Supplier Code",
//     label: "Label",
//     tension: "Tension",
//     colour: "Colour",
//     size: "Size",
//     made_in: "Made In"
//   };
//   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

//   /* ---------------------------------------------------------------
//    * Shared, progressively-growing product index for THIS page load.
//    * ------------------------------------------------------------- */
//   var indexState = {
//     products: [], // grows as batches complete
//     byId: {},
//     complete: false,
//     startedAt: null,
//     listeners: [] // functions called after every batch update
//   };

//   function notifyProgress() {
//     indexState.listeners.forEach(function (fn) {
//       try {
//         fn(indexState.products, indexState.complete);
//       } catch (e) {
//         /* ignore listener errors */
//       }
//     });
//   }

//   function onIndexProgress(fn) {
//     indexState.listeners.push(fn);
//     return function unsubscribe() {
//       var i = indexState.listeners.indexOf(fn);
//       if (i !== -1) indexState.listeners.splice(i, 1);
//     };
//   }

//   function fetchJson(url) {
//     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
//     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
//       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
//       return res.json();
//     });
//   }

//   function fetchAllCollectionHandles() {
//     return fetchJson(FEED_URL + "?page=1").then(function (first) {
//       var handles = (first.collections || []).slice();
//       var totalPages = first.pages || 1;
//       if (totalPages <= 1) return handles;

//       var pagePromises = [];
//       for (var p = 2; p <= totalPages; p++) {
//         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
//       }
//       return Promise.all(pagePromises).then(function (rest) {
//         rest.forEach(function (pageData) {
//           handles = handles.concat(pageData.collections || []);
//         });
//         return handles;
//       });
//     });
//   }

//   var buildPromise = null;

//   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
//   // This alone gives broad coverage quickly, including the first 250
//   // products of even the largest collection. Phase 2 then fills in any
//   // remaining pages, processing smaller leftovers first and the
//   // biggest collection's remaining pages last, so early progress
//   // updates aren't blocked waiting on the whole catalog.
//   function startBuildingIndex() {
//     if (buildPromise) return buildPromise;

//     indexState.startedAt = Date.now();
//     console.log("[CMS] building product index (two-phase, progressive)...");

//     buildPromise = (async function () {
//       try {
//         var handles = await fetchAllCollectionHandles();
//         console.log("[CMS] found", handles.length, "collections");

//         function addProducts(products) {
//           products.forEach(function (p) {
//             if (!indexState.byId[p.id]) {
//               indexState.byId[p.id] = p;
//               indexState.products.push(p);
//             }
//           });
//         }

//         // ---- Phase 1: page 1 of every collection ----
//         var needsMore = []; // { handle, pages }
//         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
//           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
//           var batchResults = await Promise.all(
//             batch.map(function (handle) {
//               var base =
//                 "/collections/" +
//                 encodeURIComponent(handle) +
//                 "?view=feed&sort_by=title-ascending";
//               return fetchJson(base + "&page=1")
//                 .then(function (data) {
//                   return { handle: handle, data: data };
//                 })
//                 .catch(function (err) {
//                   console.error("[CMS] failed fetching", handle, "page 1", err);
//                   return null;
//                 });
//             })
//           );

//           batchResults.forEach(function (result) {
//             if (!result) return;
//             addProducts(result.data.products || []);
//             var totalPages = result.data.pages || 1;
//             if (totalPages > 1) {
//               needsMore.push({ handle: result.handle, pages: totalPages });
//             }
//           });

//           notifyProgress(); // fast, broad progress after each small batch
//         }

//         console.log(
//           "[CMS] phase 1 done:",
//           indexState.products.length,
//           "products from page-1 of every collection.",
//           needsMore.length,
//           "collections have more pages."
//         );

//         // ---- Phase 2: remaining pages, smallest leftovers first ----
//         needsMore.sort(function (a, b) {
//           return a.pages - b.pages;
//         });

//         for (var j = 0; j < needsMore.length; j++) {
//           var entry = needsMore[j];
//           var base2 =
//             "/collections/" +
//             encodeURIComponent(entry.handle) +
//             "?view=feed&sort_by=title-ascending";

//           var remainingPagePromises = [];
//           for (var p = 2; p <= entry.pages; p++) {
//             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
//           }

//           try {
//             var pagesData = await Promise.all(remainingPagePromises);
//             pagesData.forEach(function (pageData) {
//               addProducts(pageData.products || []);
//             });
//           } catch (err) {
//             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
//           }

//           notifyProgress(); // update after each collection's remaining pages finish
//         }

//         indexState.complete = true;
//         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
//         console.log(
//           "[CMS] index complete:",
//           indexState.products.length,
//           "products in",
//           seconds + "s"
//         );
//         notifyProgress();
//       } catch (err) {
//         console.error("[CMS] building index FAILED:", err);
//       }
//     })();

//     return buildPromise;
//   }

//   function normalise(str) {
//     return (str || "").toString().toLowerCase().trim();
//   }

//   function alnumOnly(str) {
//     return normalise(str).replace(/[^a-z0-9]/g, "");
//   }

//   function matchProduct(product, q) {
//     var title = normalise(product.title);
//     if (title.indexOf(q) !== -1) {
//       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
//     }

//     if (product.sku) {
//       var skuNorm = alnumOnly(product.sku);
//       var qNorm = alnumOnly(q);
//       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
//         return { field: "sku", score: 90 };
//       }
//     }

//     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
//       var key = METAFIELD_KEYS[i];
//       if (key === "sku") continue;
//       var val = normalise(product[key]);
//       if (val && val.indexOf(q) !== -1) {
//         return { field: key, score: 60 };
//       }
//     }
//     return null;
//   }

//   function searchProducts(query, products, limit) {
//     var q = normalise(query);
//     if (q.length < MIN_QUERY_LENGTH) return [];

//     var results = [];
//     for (var i = 0; i < products.length; i++) {
//       var match = matchProduct(products[i], q);
//       if (match) {
//         results.push({ product: products[i], matchedField: match.field, score: match.score });
//       }
//     }

//     results.sort(function (a, b) {
//       return b.score - a.score;
//     });

//     return results.slice(0, limit || MAX_RESULTS);
//   }

//   function escapeHtml(str) {
//     var div = document.createElement("div");
//     div.textContent = str == null ? "" : String(str);
//     return div.innerHTML;
//   }

//   function renderDropdown(container, results, query, stillLoading) {
//     if (!results.length) {
//       if (stillLoading) {
//         container.innerHTML =
//           '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//       } else {
//         container.innerHTML =
//           '<div class="cms-no-results">No results for &ldquo;' +
//           escapeHtml(query) +
//           "&rdquo;</div>" +
//           '<button type="button" class="cms-view-all-btn">View all results</button>';
//       }
//       container.hidden = false;
//       return;
//     }

//     var html = '<ul class="cms-results-list" role="listbox">';
//     results.forEach(function (r) {
//       var p = r.product;
//       var matchLine = "";
//       if (r.matchedField) {
//         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
//         matchLine =
//           '<span class="cms-result-match">' +
//           escapeHtml(label) +
//           ": " +
//           escapeHtml(p[r.matchedField]) +
//           "</span>";
//       }
//       html +=
//         '<li class="cms-result-item" role="option">' +
//         '<a href="' +
//         escapeHtml(p.url) +
//         '" class="cms-result-link">' +
//         (p.image
//           ? '<img class="cms-result-image" src="' +
//             escapeHtml(p.image) +
//             '" alt="" loading="lazy" width="48" height="48">'
//           : '<span class="cms-result-image cms-result-image--empty"></span>') +
//         '<span class="cms-result-text">' +
//         '<span class="cms-result-title">' +
//         escapeHtml(p.title) +
//         "</span>" +
//         matchLine +
//         "</span>" +
//         "</a>" +
//         "</li>";
//     });
//     html += "</ul>";

//     html +=
//       '<button type="button" class="cms-view-all-btn">View all results</button>';

//     container.innerHTML = html;
//     container.hidden = false;
//   }

//   function debounce(fn, wait) {
//     var timer = null;
//     return function () {
//       var args = arguments;
//       var ctx = this;
//       clearTimeout(timer);
//       timer = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   var sharedContainer = null;

//   function ensureContainer(input) {
//     if (!sharedContainer) {
//       sharedContainer = document.createElement("div");
//       sharedContainer.id = "cms-metafield-results-shared";
//       sharedContainer.className = "cms-metafield-results";
//       sharedContainer.hidden = true;
//     }
//     var form = input.closest("form");
//     var anchor = form || input;
//     if (sharedContainer.previousElementSibling !== anchor) {
//       anchor.insertAdjacentElement("afterend", sharedContainer);
//     }
//     return sharedContainer;
//   }

//   var activeUnsubscribe = null;

//   function runDropdownSearch(input, container) {
//     var query = input.value;

//     if (activeUnsubscribe) {
//       activeUnsubscribe();
//       activeUnsubscribe = null;
//     }

//     if (normalise(query).length < MIN_QUERY_LENGTH) {
//       container.hidden = true;
//       container.innerHTML = "";
//       return;
//     }

//     // Show a loading state immediately.
//     container.innerHTML =
//       '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//     container.hidden = false;

//     startBuildingIndex();

//     function renderNow() {
//       // Always read the CURRENT input value, in case the user kept
//       // typing while a batch was loading — avoids showing stale results.
//       var currentQuery = input.value;
//       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
//       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
//       renderDropdown(container, results, currentQuery, !indexState.complete);
//     }

//     renderNow(); // render with whatever's loaded so far, immediately
//     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
//   }

//   var handleInputDebounced = debounce(function (input, container) {
//     runDropdownSearch(input, container);
//   }, DEBOUNCE_MS);

//   function getRealTarget(e) {
//     if (typeof e.composedPath === "function") {
//       var path = e.composedPath();
//       if (path && path.length) return path[0];
//     }
//     return e.target;
//   }

//   function init() {
//     console.log("[CMS] custom-metafield-search.js initialised");

//     document.addEventListener(
//       "focus",
//       function (e) {
//         var target = getRealTarget(e);
//         if (target && target.classList && target.classList.contains("js-search-input")) {
//           startBuildingIndex(); // warm up the index as soon as the box is focused
//         }
//       },
//       true
//     );

//     document.addEventListener("input", function (e) {
//       var input = getRealTarget(e);
//       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
//       var container = ensureContainer(input);
//       handleInputDebounced(input, container);
//     });

//     document.addEventListener("click", function (e) {
//       var target = getRealTarget(e);

//       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
//         var form = sharedContainer && sharedContainer.previousElementSibling;
//         if (form && form.tagName === "FORM") {
//           if (typeof form.requestSubmit === "function") {
//             form.requestSubmit();
//           } else {
//             form.submit();
//           }
//         }
//         return;
//       }

//       if (
//         sharedContainer &&
//         !sharedContainer.hidden &&
//         target !== sharedContainer &&
//         !sharedContainer.contains(target) &&
//         !(target && target.classList && target.classList.contains("js-search-input"))
//       ) {
//         sharedContainer.hidden = true;
//       }
//     });

//     // Enter / form submit: intentionally left as the theme's native/
//     // default behaviour (not intercepted). Only the typing dropdown
//     // above is custom.
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();


/**
 * FILE: assets/custom-metafield-search.js
 *
 * Unified custom product search (title + metafields + SKU), replacing
 * Shopify's native predictive search dropdown (hidden via CSS in
 * custom-metafield-search.css).
 *
 * DATA SOURCE: collections.all proved unreliable on this store's large
 * catalog (25,000+ products). Instead, this fetches the list of all
 * collection handles (templates/page.search-index.liquid), then fetches
 * each collection's own product feed (templates/collection.feed.liquid,
 * via /collections/<handle>?view=feed&sort_by=title-ascending) and
 * merges/dedupes by product ID. The sort_by=title-ascending part is
 * required — without it, pagination on very large collections silently
 * drops some products between page boundaries.
 *
 * PROGRESSIVE RESULTS: Collections are fetched in small parallel
 * batches. Instead of waiting for every collection to finish before
 * showing anything, the search re-runs and updates the visible results
 * after EACH batch completes — so results appear quickly and get more
 * complete as loading continues, with a "Still loading…" note shown
 * until everything has arrived.
 *
 * NATIVE /search PAGE AUGMENTATION: Shopify's own search engine only
 * matches full/whole SKU tokens (e.g. "S-EP4461C"), not partial ones
 * (e.g. "4461C"). So when the native /search page returns 0 results
 * for a query that DOES match a SKU/metafield substring, this script
 * builds its own results grid and injects matching product cards —
 * either into the theme's existing #filter-results > ul.grid (if it
 * exists), or, when the theme renders no results container at all
 * (its typical behaviour on 0 native results), by finding the
 * "No results found" message on the page and inserting a grid right
 * after it, removing that message once real matches are found. This
 * runs automatically on every /search page load — no manual step,
 * no theme template changes needed after this file is installed.
 *
 * SETUP:
 * 1. assets/custom-metafield-search.js (this file)
 * 2. assets/custom-metafield-search.css
 * 3. templates/page.search-index.liquid (collection handle list; assign
 *    as a Page's Theme template)
 * 4. templates/collection.feed.liquid (per-collection product feed; no
 *    Admin assignment needed, works via ?view=feed)
 * 5. templates/page.search-results.liquid + a "Search Results" Page
 *    using it, if the full results page is enabled
 * 6. In theme.liquid (just before </body>):
 *      <script src="{{ 'custom-metafield-search.js' | asset_url }}" defer="defer"></script>
 *      {{ 'custom-metafield-search.css' | asset_url | stylesheet_tag }}
 */
// (function () {
//   "use strict";

//   var FEED_URL = "/pages/search-index";
//   var MIN_QUERY_LENGTH = 2;
//   var MAX_RESULTS = 3;
//   var DEBOUNCE_MS = 200;
//   var COLLECTION_BATCH_SIZE = 5;

//   var METAFIELD_LABELS = {
//     sku: "SKU",
//     instrumentation: "Instrumentation",
//     composer: "Composer",
//     arranger: "Arranger",
//     contents_list: "Contents",
//     isbn13: "ISBN13",
//     upc: "UPC",
//     supplier_code: "Supplier Code",
//     label: "Label",
//     tension: "Tension",
//     colour: "Colour",
//     size: "Size",
//     made_in: "Made In"
//   };
//   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

//   /* ---------------------------------------------------------------
//    * Shared, progressively-growing product index for THIS page load.
//    * ------------------------------------------------------------- */
//   var indexState = {
//     products: [], // grows as batches complete
//     byId: {},
//     complete: false,
//     startedAt: null,
//     listeners: [] // functions called after every batch update
//   };

//   function notifyProgress() {
//     indexState.listeners.forEach(function (fn) {
//       try {
//         fn(indexState.products, indexState.complete);
//       } catch (e) {
//         /* ignore listener errors */
//       }
//     });
//   }

//   function onIndexProgress(fn) {
//     indexState.listeners.push(fn);
//     return function unsubscribe() {
//       var i = indexState.listeners.indexOf(fn);
//       if (i !== -1) indexState.listeners.splice(i, 1);
//     };
//   }

//   function fetchJson(url) {
//     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
//     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
//       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
//       return res.json();
//     });
//   }

//   function fetchAllCollectionHandles() {
//     return fetchJson(FEED_URL + "?page=1").then(function (first) {
//       var handles = (first.collections || []).slice();
//       var totalPages = first.pages || 1;
//       if (totalPages <= 1) return handles;

//       var pagePromises = [];
//       for (var p = 2; p <= totalPages; p++) {
//         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
//       }
//       return Promise.all(pagePromises).then(function (rest) {
//         rest.forEach(function (pageData) {
//           handles = handles.concat(pageData.collections || []);
//         });
//         return handles;
//       });
//     });
//   }

//   var buildPromise = null;

//   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
//   // This alone gives broad coverage quickly, including the first 250
//   // products of even the largest collection. Phase 2 then fills in any
//   // remaining pages, processing smaller leftovers first and the
//   // biggest collection's remaining pages last, so early progress
//   // updates aren't blocked waiting on the whole catalog.
//   function startBuildingIndex() {
//     if (buildPromise) return buildPromise;

//     indexState.startedAt = Date.now();
//     console.log("[CMS] building product index (two-phase, progressive)...");

//     buildPromise = (async function () {
//       try {
//         var handles = await fetchAllCollectionHandles();
//         console.log("[CMS] found", handles.length, "collections");

//         function addProducts(products) {
//           products.forEach(function (p) {
//             if (!indexState.byId[p.id]) {
//               indexState.byId[p.id] = p;
//               indexState.products.push(p);
//             }
//           });
//         }

//         // ---- Phase 1: page 1 of every collection ----
//         var needsMore = []; // { handle, pages }
//         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
//           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
//           var batchResults = await Promise.all(
//             batch.map(function (handle) {
//               var base =
//                 "/collections/" +
//                 encodeURIComponent(handle) +
//                 "?view=feed&sort_by=title-ascending";
//               return fetchJson(base + "&page=1")
//                 .then(function (data) {
//                   return { handle: handle, data: data };
//                 })
//                 .catch(function (err) {
//                   console.error("[CMS] failed fetching", handle, "page 1", err);
//                   return null;
//                 });
//             })
//           );

//           batchResults.forEach(function (result) {
//             if (!result) return;
//             addProducts(result.data.products || []);
//             var totalPages = result.data.pages || 1;
//             if (totalPages > 1) {
//               needsMore.push({ handle: result.handle, pages: totalPages });
//             }
//           });

//           notifyProgress(); // fast, broad progress after each small batch
//         }

//         console.log(
//           "[CMS] phase 1 done:",
//           indexState.products.length,
//           "products from page-1 of every collection.",
//           needsMore.length,
//           "collections have more pages."
//         );

//         // ---- Phase 2: remaining pages, smallest leftovers first ----
//         needsMore.sort(function (a, b) {
//           return a.pages - b.pages;
//         });

//         for (var j = 0; j < needsMore.length; j++) {
//           var entry = needsMore[j];
//           var base2 =
//             "/collections/" +
//             encodeURIComponent(entry.handle) +
//             "?view=feed&sort_by=title-ascending";

//           var remainingPagePromises = [];
//           for (var p = 2; p <= entry.pages; p++) {
//             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
//           }

//           try {
//             var pagesData = await Promise.all(remainingPagePromises);
//             pagesData.forEach(function (pageData) {
//               addProducts(pageData.products || []);
//             });
//           } catch (err) {
//             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
//           }

//           notifyProgress(); // update after each collection's remaining pages finish
//         }

//         indexState.complete = true;
//         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
//         console.log(
//           "[CMS] index complete:",
//           indexState.products.length,
//           "products in",
//           seconds + "s"
//         );
//         notifyProgress();
//       } catch (err) {
//         console.error("[CMS] building index FAILED:", err);
//       }
//     })();

//     return buildPromise;
//   }

//   function normalise(str) {
//     return (str || "").toString().toLowerCase().trim();
//   }

//   function alnumOnly(str) {
//     return normalise(str).replace(/[^a-z0-9]/g, "");
//   }

//   function matchProduct(product, q) {
//     var title = normalise(product.title);
//     if (title.indexOf(q) !== -1) {
//       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
//     }

//     if (product.sku) {
//       var skuNorm = alnumOnly(product.sku);
//       var qNorm = alnumOnly(q);
//       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
//         return { field: "sku", score: 90 };
//       }
//     }

//     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
//       var key = METAFIELD_KEYS[i];
//       if (key === "sku") continue;
//       var val = normalise(product[key]);
//       if (val && val.indexOf(q) !== -1) {
//         return { field: key, score: 60 };
//       }
//     }
//     return null;
//   }

//   function searchProducts(query, products, limit) {
//     var q = normalise(query);
//     if (q.length < MIN_QUERY_LENGTH) return [];

//     var results = [];
//     for (var i = 0; i < products.length; i++) {
//       var match = matchProduct(products[i], q);
//       if (match) {
//         results.push({ product: products[i], matchedField: match.field, score: match.score });
//       }
//     }

//     results.sort(function (a, b) {
//       return b.score - a.score;
//     });

//     return results.slice(0, limit || MAX_RESULTS);
//   }

//   function escapeHtml(str) {
//     var div = document.createElement("div");
//     div.textContent = str == null ? "" : String(str);
//     return div.innerHTML;
//   }

//   function renderDropdown(container, results, query, stillLoading) {
//     if (!results.length) {
//       if (stillLoading) {
//         container.innerHTML =
//           '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//       } else {
//         container.innerHTML =
//           '<div class="cms-no-results">No results for &ldquo;' +
//           escapeHtml(query) +
//           "&rdquo;</div>" +
//           '<button type="button" class="cms-view-all-btn">View all results</button>';
//       }
//       container.hidden = false;
//       return;
//     }

//     var html = '<ul class="cms-results-list" role="listbox">';
//     results.forEach(function (r) {
//       var p = r.product;
//       var matchLine = "";
//       if (r.matchedField) {
//         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
//         matchLine =
//           '<span class="cms-result-match">' +
//           escapeHtml(label) +
//           ": " +
//           escapeHtml(p[r.matchedField]) +
//           "</span>";
//       }
//       html +=
//         '<li class="cms-result-item" role="option">' +
//         '<a href="' +
//         escapeHtml(p.url) +
//         '" class="cms-result-link">' +
//         (p.image
//           ? '<img class="cms-result-image" src="' +
//             escapeHtml(p.image) +
//             '" alt="" loading="lazy" width="48" height="48">'
//           : '<span class="cms-result-image cms-result-image--empty"></span>') +
//         '<span class="cms-result-text">' +
//         '<span class="cms-result-title">' +
//         escapeHtml(p.title) +
//         "</span>" +
//         matchLine +
//         "</span>" +
//         "</a>" +
//         "</li>";
//     });
//     html += "</ul>";

//     html +=
//       '<button type="button" class="cms-view-all-btn">View all results</button>';

//     container.innerHTML = html;
//     container.hidden = false;
//   }

//   function debounce(fn, wait) {
//     var timer = null;
//     return function () {
//       var args = arguments;
//       var ctx = this;
//       clearTimeout(timer);
//       timer = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   var sharedContainer = null;

//   function ensureContainer(input) {
//     if (!sharedContainer) {
//       sharedContainer = document.createElement("div");
//       sharedContainer.id = "cms-metafield-results-shared";
//       sharedContainer.className = "cms-metafield-results";
//       sharedContainer.hidden = true;
//     }
//     var form = input.closest("form");
//     var anchor = form || input;
//     if (sharedContainer.previousElementSibling !== anchor) {
//       anchor.insertAdjacentElement("afterend", sharedContainer);
//     }
//     return sharedContainer;
//   }

//   var activeUnsubscribe = null;

//   function runDropdownSearch(input, container) {
//     var query = input.value;

//     if (activeUnsubscribe) {
//       activeUnsubscribe();
//       activeUnsubscribe = null;
//     }

//     if (normalise(query).length < MIN_QUERY_LENGTH) {
//       container.hidden = true;
//       container.innerHTML = "";
//       return;
//     }

//     // Show a loading state immediately.
//     container.innerHTML =
//       '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//     container.hidden = false;

//     startBuildingIndex();

//     function renderNow() {
//       // Always read the CURRENT input value, in case the user kept
//       // typing while a batch was loading — avoids showing stale results.
//       var currentQuery = input.value;
//       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
//       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
//       renderDropdown(container, results, currentQuery, !indexState.complete);
//     }

//     renderNow(); // render with whatever's loaded so far, immediately
//     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
//   }

//   var handleInputDebounced = debounce(function (input, container) {
//     runDropdownSearch(input, container);
//   }, DEBOUNCE_MS);

//   /* ---------------------------------------------------------------
//    * Inject extra matches (metafields/SKU) directly into the native
//    * /search results grid (<ul class="grid"> inside #filter-results),
//    * as real <li> items using the theme's own card classes — so they
//    * look like normal results, not a separate section.
//    *
//    * Two scenarios are handled:
//    *   1. Theme found >=1 native result: #filter-results and its
//    *      ul.grid already exist — we just append into that same grid.
//    *   2. Theme found 0 native results: many themes render NO
//    *      #filter-results container at all in this case, just a
//    *      "No results found" message. We locate that message and
//    *      build our own grid directly after it, then remove the
//    *      message once we have real matches to show — so the page
//    *      never shows both "No results found" and actual results.
//    * ------------------------------------------------------------- */
//   function findNoResultsElement() {
//     var candidates = document.querySelectorAll("body *");
//     for (var i = 0; i < candidates.length; i++) {
//       var el = candidates[i];
//       // Match on the smallest element containing the phrase, so we
//       // don't grab a huge wrapper (e.g. <body> or <main>) by mistake.
//       if (el.children.length === 0 && /no results found/i.test(el.textContent || "")) {
//         return el;
//       }
//     }
//     return null;
//   }

//   function findResultsGrid() {
//     var scope = document.getElementById("filter-results");
//     if (scope) {
//       var existing = scope.querySelector("ul.grid");
//       if (existing) return existing;

//       // With 0 native results AND available filters, some themes render
//       // an "empty" message instead of the <ul class="grid">, so it
//       // doesn't exist in the DOM at all even though #filter-results
//       // does. Create one ourselves so we still have somewhere to
//       // inject matching cards.
//       var ul = document.createElement("ul");
//       ul.className =
//         "grid mb-8 md:mb-12 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-theme gap-y-10";
//       ul.setAttribute("role", "list");
//       scope.appendChild(ul);
//       return ul;
//     }

//     // Fallback: the theme renders NOTHING resembling #filter-results
//     // when native search returns 0 results — just a plain
//     // "No results found" message somewhere on the page. Find that
//     // message directly and build our own grid right after it.
//     var noResultsEl = findNoResultsElement();
//     if (!noResultsEl) return null;

//     var existingFallback = document.getElementById("cms-fallback-grid");
//     if (existingFallback) return existingFallback;

//     var ul2 = document.createElement("ul");
//     ul2.id = "cms-fallback-grid";
//     ul2.className =
//       "grid mb-8 md:mb-12 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-theme gap-y-10";
//     ul2.setAttribute("role", "list");
//     noResultsEl.insertAdjacentElement("afterend", ul2);
//     return ul2;
//   }

//   function buildCardListItem(product, matchedField) {
//     var li = document.createElement("li");
//     li.className = "js-pagination-result cms-extra-result";
//     li.setAttribute("data-product-id", product.id);

//     var imageHtml = product.image
//       ? '<img class="img-fit card__main-image" src="' +
//         escapeHtml(product.image) +
//         '" alt="" loading="lazy" width="300" height="300">'
//       : "";

//     var matchLine = "";
//     if (matchedField) {
//       var label = METAFIELD_LABELS[matchedField] || matchedField;
//       matchLine =
//         '<p class="cms-extra-match text-sm text-theme-light mt-1 mb-0">' +
//         escapeHtml(label) +
//         ": " +
//         escapeHtml(product[matchedField]) +
//         "</p>";
//     }

//     li.innerHTML =
//       '<div class="card card--product h-full flex relative">' +
//       '<div class="card__media relative">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" aria-label="' +
//       escapeHtml(product.title) +
//       '" class="media block relative" style="padding-top: 100%;">' +
//       imageHtml +
//       "</a>" +
//       "</div>" +
//       '<div class="card__info-container flex flex-col flex-auto relative">' +
//       '<div class="card__info w-full">' +
//       '<div class="card__info-inner inline-block w-full">' +
//       '<p class="card__title font-bold mt-1 mb-0">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" class="card-link text-current">' +
//       escapeHtml(product.title) +
//       "</a>" +
//       "</p>" +
//       matchLine +
//       (product.price
//         ? '<div class="card__price theme-money">' + escapeHtml(product.price) + "</div>"
//         : "") +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>";

//     return li;
//   }

//   function getNativeResultIds(grid) {
//     var ids = {};
//     grid.querySelectorAll("[data-product-id]").forEach(function (el) {
//       var id = el.getAttribute("data-product-id");
//       if (id) ids[id] = true;
//     });
//     return ids;
//   }

//   function renderNativeExtraResults(results) {
//     var grid = findResultsGrid();
//     if (!grid) return; // no grid and no "No results found" message found — nothing to do

//     // Remove any previously-injected items before re-adding (progressive
//     // updates re-render the full result set each time).
//     grid.querySelectorAll(".cms-extra-result").forEach(function (el) {
//       el.remove();
//     });

//     // Avoid duplicating a product that the theme's own native search
//     // already placed in the grid (relevant when native results > 0).
//     var nativeIds = getNativeResultIds(grid);

//     var addedAny = false;
//     results.forEach(function (r) {
//       if (nativeIds[r.product.id]) return; // already shown natively, skip
//       grid.appendChild(buildCardListItem(r.product, r.matchedField));
//       addedAny = true;
//     });

//     // We're on the fallback grid (native search had 0 results) and we
//     // found real matches — the theme's "No results found" message
//     // above it is now inaccurate, so remove it.
//     if (grid.id === "cms-fallback-grid" && addedAny) {
//       var noResultsEl = findNoResultsElement();
//       if (noResultsEl) noResultsEl.remove();
//     }
//   }

//   /**
//    * If the typed query matches EXACTLY ONE product's SKU (title
//    * matches don't count here — only a SKU/metafield substring match),
//    * redirect the browser to /search?q=<that product's full SKU>. This
//    * hands the query back to Shopify's OWN native search, which already
//    * matches full SKUs correctly — so the resulting page is a normal,
//    * fully-native results page (correct URL, correct markup, no custom
//    * grid needed).
//    *
//    * If MULTIPLE products match (ambiguous — redirecting would hide
//    * the others), this does nothing and the caller falls back to
//    * injecting all matches into a grid instead.
//    *
//    * Returns true if a redirect was triggered (caller should stop).
//    */
//   function attemptSkuRedirect(query) {
//     var q = normalise(query);
//     var results = searchProducts(query, indexState.products, 50);
//     var skuMatches = results.filter(function (r) {
//       return r.matchedField === "sku";
//     });

//     if (skuMatches.length !== 1) return false; // none, or ambiguous — skip

//     var fullSku = skuMatches[0].product.sku;
//     if (!fullSku || normalise(fullSku) === q) return false; // already this exact value — avoid redirect loop

//     var params = new URLSearchParams(window.location.search);
//     params.set("q", fullSku);
//     var newUrl = window.location.pathname + "?" + params.toString();
//     console.log("[CMS] redirecting partial SKU query to full SKU:", query, "->", fullSku);
//     window.location.replace(newUrl);
//     return true;
//   }

//   function initNativeSearchAugmentation() {
//     if (window.location.pathname.indexOf("/search") !== 0) return;

//     var params = new URLSearchParams(window.location.search);
//     var query = params.get("q") || "";
//     if (normalise(query).length < MIN_QUERY_LENGTH) return;

//     // If native search already returned real results, nothing to do —
//     // full/whole SKU and title queries already work natively.
//     var scope = document.getElementById("filter-results");
//     var nativeGrid = scope && scope.querySelector("ul.grid");
//     var nativeHasResults = !!(nativeGrid && nativeGrid.children.length > 0);
//     if (nativeHasResults) return;

//     var redirected = false;

//     startBuildingIndex();

//     function tryRedirectOrRender() {
//       if (redirected) return;

//       // IMPORTANT: only decide to redirect once the FULL product index
//       // has finished loading. Deciding earlier (mid-way through the
//       // progressive load) risks seeing only 1 match right now when 2
//       // more matching products haven't been indexed yet — which would
//       // wrongly redirect away before the other matches are found.
//       if (indexState.complete && attemptSkuRedirect(query)) {
//         redirected = true;
//         return;
//       }

//       // Either still loading, or loading finished and it's genuinely
//       // ambiguous (multiple SKU matches) — show whatever matches we
//       // have so far in a fallback grid instead.
//       var results = searchProducts(query, indexState.products, 10);
//       renderNativeExtraResults(results);
//     }

//     onIndexProgress(tryRedirectOrRender);
//     tryRedirectOrRender();
//   }

//   function getRealTarget(e) {
//     if (typeof e.composedPath === "function") {
//       var path = e.composedPath();
//       if (path && path.length) return path[0];
//     }
//     return e.target;
//   }

//   function init() {
//     console.log("[CMS] custom-metafield-search.js initialised");

//     initNativeSearchAugmentation();

//     document.addEventListener(
//       "focus",
//       function (e) {
//         var target = getRealTarget(e);
//         if (target && target.classList && target.classList.contains("js-search-input")) {
//           startBuildingIndex(); // warm up the index as soon as the box is focused
//         }
//       },
//       true
//     );

//     document.addEventListener("input", function (e) {
//       var input = getRealTarget(e);
//       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
//       var container = ensureContainer(input);
//       handleInputDebounced(input, container);
//     });

//     document.addEventListener("click", function (e) {
//       var target = getRealTarget(e);

//       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
//         var form = sharedContainer && sharedContainer.previousElementSibling;
//         if (form && form.tagName === "FORM") {
//           var inputEl =
//             form.querySelector(".js-search-input") || form.querySelector('input[name="q"]');
//           var typedQuery = inputEl ? inputEl.value : "";

//           // If the typed text resolves to exactly one product's SKU,
//           // send the browser straight to /search?q=<full SKU> instead
//           // of submitting the raw partial text — Shopify's native
//           // search matches the full SKU correctly, so this lands on a
//           // normal, fully-native results page.
//           // Same safeguard as the /search page: only trust "exactly
//           // one SKU match" once the full index has loaded, otherwise
//           // we might redirect based on a partial, still-loading list.
//           var skuMatch = null;
//           if (typedQuery && indexState.complete) {
//             var results = searchProducts(typedQuery, indexState.products, 50);
//             var skuMatches = results.filter(function (r) {
//               return r.matchedField === "sku";
//             });
//             if (skuMatches.length === 1) skuMatch = skuMatches[0].product.sku;
//           }

//           if (skuMatch && normalise(skuMatch) !== normalise(typedQuery)) {
//             window.location.href = "/search?q=" + encodeURIComponent(skuMatch);
//           } else if (typeof form.requestSubmit === "function") {
//             form.requestSubmit();
//           } else {
//             form.submit();
//           }
//         }
//         return;
//       }

//       if (
//         sharedContainer &&
//         !sharedContainer.hidden &&
//         target !== sharedContainer &&
//         !sharedContainer.contains(target) &&
//         !(target && target.classList && target.classList.contains("js-search-input"))
//       ) {
//         sharedContainer.hidden = true;
//       }
//     });

//     // Enter / form submit: intentionally left as the theme's native/
//     // default behaviour (not intercepted). Only the typing dropdown
//     // above is custom.
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();


/**
 * FILE: assets/custom-metafield-search.js
 *
 * Unified custom product search (title + metafields + SKU), replacing
 * Shopify's native predictive search dropdown (hidden via CSS in
 * custom-metafield-search.css).
 *
 * DATA SOURCE: collections.all proved unreliable on this store's large
 * catalog (25,000+ products). Instead, this fetches the list of all
 * collection handles (templates/page.search-index.liquid), then fetches
 * each collection's own product feed (templates/collection.feed.liquid,
 * via /collections/<handle>?view=feed&sort_by=title-ascending) and
 * merges/dedupes by product ID. The sort_by=title-ascending part is
 * required — without it, pagination on very large collections silently
 * drops some products between page boundaries.
 *
 * PROGRESSIVE RESULTS: Collections are fetched in small parallel
 * batches. Instead of waiting for every collection to finish before
 * showing anything, the search re-runs and updates the visible results
 * after EACH batch completes — so results appear quickly and get more
 * complete as loading continues.
 *
 * NATIVE /search PAGE AUGMENTATION: Shopify's own search engine only
 * matches full/whole SKU tokens (e.g. "S-EP4461C"), not partial ones
 * (e.g. "4461C"). So when the native /search page returns 0 results
 * for a query that DOES match a SKU/metafield substring, this script
 * either:
 *   (a) redirects to the full SKU (so the resulting page is a normal,
 *       fully-native results page), when exactly one product matches, or
 *   (b) builds its own results grid and injects matching product cards
 *       — either into the theme's existing #filter-results > ul.grid
 *       (if it exists), or, when the theme renders no results
 *       container at all, by finding the "No results found" message
 *       and inserting a grid right after it, removing that message
 *       once real matches are found.
 * This runs automatically on every /search page load — no manual step.
 *
 * SETUP:
 * 1. assets/custom-metafield-search.js (this file)
 * 2. assets/custom-metafield-search.css
 * 3. templates/page.search-index.liquid (collection handle list; assign
 *    as a Page's Theme template)
 * 4. templates/collection.feed.liquid (per-collection product feed; no
 *    Admin assignment needed, works via ?view=feed)
 * 5. In theme.liquid (just before </body>):
 *      <script src="{{ 'custom-metafield-search.js' | asset_url }}" defer="defer"></script>
 *      {{ 'custom-metafield-search.css' | asset_url | stylesheet_tag }}
 */
// (function () {
//   "use strict";

//   var FEED_URL = "/pages/search-index";
//   var MIN_QUERY_LENGTH = 2;
//   var MAX_RESULTS = 3;
//   var DEBOUNCE_MS = 200;
//   var COLLECTION_BATCH_SIZE = 5;

//   var METAFIELD_LABELS = {
//     sku: "SKU",
//     instrumentation: "Instrumentation",
//     composer: "Composer",
//     arranger: "Arranger",
//     contents_list: "Contents",
//     isbn13: "ISBN13",
//     upc: "UPC",
//     supplier_code: "Supplier Code",
//     label: "Label",
//     tension: "Tension",
//     colour: "Colour",
//     size: "Size",
//     made_in: "Made In"
//   };
//   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

//   /* ---------------------------------------------------------------
//    * Shared, progressively-growing product index for THIS page load.
//    * ------------------------------------------------------------- */
//   var indexState = {
//     products: [], // grows as batches complete
//     byId: {},
//     complete: false,
//     startedAt: null,
//     listeners: [] // functions called after every batch update
//   };

//   function notifyProgress() {
//     indexState.listeners.forEach(function (fn) {
//       try {
//         fn(indexState.products, indexState.complete);
//       } catch (e) {
//         /* ignore listener errors */
//       }
//     });
//   }

//   function onIndexProgress(fn) {
//     indexState.listeners.push(fn);
//     return function unsubscribe() {
//       var i = indexState.listeners.indexOf(fn);
//       if (i !== -1) indexState.listeners.splice(i, 1);
//     };
//   }

//   function fetchJson(url) {
//     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
//     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
//       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
//       return res.json();
//     });
//   }

//   function fetchAllCollectionHandles() {
//     return fetchJson(FEED_URL + "?page=1").then(function (first) {
//       var handles = (first.collections || []).slice();
//       var totalPages = first.pages || 1;
//       if (totalPages <= 1) return handles;

//       var pagePromises = [];
//       for (var p = 2; p <= totalPages; p++) {
//         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
//       }
//       return Promise.all(pagePromises).then(function (rest) {
//         rest.forEach(function (pageData) {
//           handles = handles.concat(pageData.collections || []);
//         });
//         return handles;
//       });
//     });
//   }

//   var buildPromise = null;

//   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
//   // This alone gives broad coverage quickly, including the first 250
//   // products of even the largest collection. Phase 2 then fills in any
//   // remaining pages, processing smaller leftovers first and the
//   // biggest collection's remaining pages last, so early progress
//   // updates aren't blocked waiting on the whole catalog.
//   function startBuildingIndex() {
//     if (buildPromise) return buildPromise;

//     indexState.startedAt = Date.now();
//     console.log("[CMS] building product index (two-phase, progressive)...");

//     buildPromise = (async function () {
//       try {
//         var handles = await fetchAllCollectionHandles();
//         console.log("[CMS] found", handles.length, "collections");

//         function addProducts(products) {
//           products.forEach(function (p) {
//             if (!indexState.byId[p.id]) {
//               indexState.byId[p.id] = p;
//               indexState.products.push(p);
//             }
//           });
//         }

//         // ---- Phase 1: page 1 of every collection ----
//         var needsMore = []; // { handle, pages }
//         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
//           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
//           var batchResults = await Promise.all(
//             batch.map(function (handle) {
//               var base =
//                 "/collections/" +
//                 encodeURIComponent(handle) +
//                 "?view=feed&sort_by=title-ascending";
//               return fetchJson(base + "&page=1")
//                 .then(function (data) {
//                   return { handle: handle, data: data };
//                 })
//                 .catch(function (err) {
//                   console.error("[CMS] failed fetching", handle, "page 1", err);
//                   return null;
//                 });
//             })
//           );

//           batchResults.forEach(function (result) {
//             if (!result) return;
//             addProducts(result.data.products || []);
//             var totalPages = result.data.pages || 1;
//             if (totalPages > 1) {
//               needsMore.push({ handle: result.handle, pages: totalPages });
//             }
//           });

//           notifyProgress(); // fast, broad progress after each small batch
//         }

//         console.log(
//           "[CMS] phase 1 done:",
//           indexState.products.length,
//           "products from page-1 of every collection.",
//           needsMore.length,
//           "collections have more pages."
//         );

//         // ---- Phase 2: remaining pages, smallest leftovers first ----
//         needsMore.sort(function (a, b) {
//           return a.pages - b.pages;
//         });

//         for (var j = 0; j < needsMore.length; j++) {
//           var entry = needsMore[j];
//           var base2 =
//             "/collections/" +
//             encodeURIComponent(entry.handle) +
//             "?view=feed&sort_by=title-ascending";

//           var remainingPagePromises = [];
//           for (var p = 2; p <= entry.pages; p++) {
//             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
//           }

//           try {
//             var pagesData = await Promise.all(remainingPagePromises);
//             pagesData.forEach(function (pageData) {
//               addProducts(pageData.products || []);
//             });
//           } catch (err) {
//             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
//           }

//           notifyProgress(); // update after each collection's remaining pages finish
//         }

//         indexState.complete = true;
//         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
//         console.log(
//           "[CMS] index complete:",
//           indexState.products.length,
//           "products in",
//           seconds + "s"
//         );
//         notifyProgress();
//       } catch (err) {
//         console.error("[CMS] building index FAILED:", err);
//       }
//     })();

//     return buildPromise;
//   }

//   function normalise(str) {
//     return (str || "").toString().toLowerCase().trim();
//   }

//   function alnumOnly(str) {
//     return normalise(str).replace(/[^a-z0-9]/g, "");
//   }

//   function matchProduct(product, q) {
//     var title = normalise(product.title);
//     if (title.indexOf(q) !== -1) {
//       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
//     }

//     if (product.sku) {
//       var skuNorm = alnumOnly(product.sku);
//       var qNorm = alnumOnly(q);
//       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
//         return { field: "sku", score: 90 };
//       }
//     }

//     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
//       var key = METAFIELD_KEYS[i];
//       if (key === "sku") continue;
//       var val = normalise(product[key]);
//       if (val && val.indexOf(q) !== -1) {
//         return { field: key, score: 60 };
//       }
//     }
//     return null;
//   }

//   function searchProducts(query, products, limit) {
//     var q = normalise(query);
//     if (q.length < MIN_QUERY_LENGTH) return [];

//     var results = [];
//     for (var i = 0; i < products.length; i++) {
//       var match = matchProduct(products[i], q);
//       if (match) {
//         results.push({ product: products[i], matchedField: match.field, score: match.score });
//       }
//     }

//     results.sort(function (a, b) {
//       return b.score - a.score;
//     });

//     return results.slice(0, limit || MAX_RESULTS);
//   }

//   function escapeHtml(str) {
//     var div = document.createElement("div");
//     div.textContent = str == null ? "" : String(str);
//     return div.innerHTML;
//   }

//   function renderDropdown(container, results, query, stillLoading) {
//     if (!results.length) {
//       if (stillLoading) {
//         container.innerHTML =
//           '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//       } else {
//         container.innerHTML =
//           '<div class="cms-no-results">No results for &ldquo;' +
//           escapeHtml(query) +
//           "&rdquo;</div>" +
//           '<button type="button" class="cms-view-all-btn">View all results</button>';
//       }
//       container.hidden = false;
//       return;
//     }

//     var html = '<ul class="cms-results-list" role="listbox">';
//     results.forEach(function (r) {
//       var p = r.product;
//       var matchLine = "";
//       if (r.matchedField) {
//         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
//         matchLine =
//           '<span class="cms-result-match">' +
//           escapeHtml(label) +
//           ": " +
//           escapeHtml(p[r.matchedField]) +
//           "</span>";
//       }
//       html +=
//         '<li class="cms-result-item" role="option">' +
//         '<a href="' +
//         escapeHtml(p.url) +
//         '" class="cms-result-link">' +
//         (p.image
//           ? '<img class="cms-result-image" src="' +
//             escapeHtml(p.image) +
//             '" alt="" loading="lazy" width="48" height="48">'
//           : '<span class="cms-result-image cms-result-image--empty"></span>') +
//         '<span class="cms-result-text">' +
//         '<span class="cms-result-title">' +
//         escapeHtml(p.title) +
//         "</span>" +
//         matchLine +
//         "</span>" +
//         "</a>" +
//         "</li>";
//     });
//     html += "</ul>";

//     html += '<button type="button" class="cms-view-all-btn">View all results</button>';

//     container.innerHTML = html;
//     container.hidden = false;
//   }

//   function debounce(fn, wait) {
//     var timer = null;
//     return function () {
//       var args = arguments;
//       var ctx = this;
//       clearTimeout(timer);
//       timer = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   var sharedContainer = null;

//   function ensureContainer(input) {
//     if (!sharedContainer) {
//       sharedContainer = document.createElement("div");
//       sharedContainer.id = "cms-metafield-results-shared";
//       sharedContainer.className = "cms-metafield-results";
//       sharedContainer.hidden = true;
//     }
//     var form = input.closest("form");
//     var anchor = form || input;
//     if (sharedContainer.previousElementSibling !== anchor) {
//       anchor.insertAdjacentElement("afterend", sharedContainer);
//     }
//     return sharedContainer;
//   }

//   var activeUnsubscribe = null;

//   function runDropdownSearch(input, container) {
//     var query = input.value;

//     if (activeUnsubscribe) {
//       activeUnsubscribe();
//       activeUnsubscribe = null;
//     }

//     if (normalise(query).length < MIN_QUERY_LENGTH) {
//       container.hidden = true;
//       container.innerHTML = "";
//       return;
//     }

//     // Show a loading state immediately.
//     container.innerHTML =
//       '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//     container.hidden = false;

//     startBuildingIndex();

//     function renderNow() {
//       // Always read the CURRENT input value, in case the user kept
//       // typing while a batch was loading — avoids showing stale results.
//       var currentQuery = input.value;
//       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
//       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
//       renderDropdown(container, results, currentQuery, !indexState.complete);
//     }

//     renderNow(); // render with whatever's loaded so far, immediately
//     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
//   }

//   var handleInputDebounced = debounce(function (input, container) {
//     runDropdownSearch(input, container);
//   }, DEBOUNCE_MS);

//   /* ---------------------------------------------------------------
//    * Inject extra matches (metafields/SKU) directly into the native
//    * /search results grid (<ul class="grid"> inside #filter-results),
//    * as real <li> items using the theme's own card classes — so they
//    * look like normal results, not a separate section.
//    *
//    * Two scenarios are handled:
//    *   1. Theme found >=1 native result: #filter-results and its
//    *      ul.grid already exist — we just append into that same grid.
//    *   2. Theme found 0 native results: many themes render NO
//    *      #filter-results container at all in this case, just a
//    *      "No results found" message. We locate that message and
//    *      build our own grid directly after it, then remove the
//    *      message once we have real matches to show — so the page
//    *      never shows both "No results found" and actual results.
//    * ------------------------------------------------------------- */
//   function findNoResultsElement() {
//     var candidates = document.querySelectorAll("body *");
//     for (var i = 0; i < candidates.length; i++) {
//       var el = candidates[i];
//       // Match on the smallest element containing the phrase, so we
//       // don't grab a huge wrapper (e.g. <body> or <main>) by mistake.
//       if (el.children.length === 0 && /no results found/i.test(el.textContent || "")) {
//         return el;
//       }
//     }
//     return null;
//   }

//   var FALLBACK_GRID_CLASSES =
//     "grid mb-8 md:mb-12 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-theme gap-y-10";

//   function findResultsGrid() {
//     var scope = document.getElementById("filter-results");
//     if (scope) {
//       var existing = scope.querySelector("ul.grid");
//       if (existing) {
//         // When native results are 0, the theme's own Liquid never
//         // assigns its responsive grid-cols-* classes to this <ul> (it
//         // only does so when search.results_count > 0), so it exists
//         // but lays out as a single stacked column with large gaps.
//         // Detect that and add sensible column classes ourselves.
//         if (existing.className.indexOf("grid-cols") === -1) {
//           existing.className = (existing.className + " " + FALLBACK_GRID_CLASSES).trim();
//         }
//         return existing;
//       }

//       // With 0 native results AND available filters, some themes render
//       // an "empty" message instead of the <ul class="grid">, so it
//       // doesn't exist in the DOM at all even though #filter-results
//       // does. Create one ourselves so we still have somewhere to
//       // inject matching cards.
//       var ul = document.createElement("ul");
//       ul.className = FALLBACK_GRID_CLASSES;
//       ul.setAttribute("role", "list");
//       scope.appendChild(ul);
//       return ul;
//     }

//     // Fallback: the theme renders NOTHING resembling #filter-results
//     // when native search returns 0 results — just a plain
//     // "No results found" message somewhere on the page. Find that
//     // message directly and build our own grid right after it.
//     var noResultsEl = findNoResultsElement();
//     if (!noResultsEl) return null;

//     var existingFallback = document.getElementById("cms-fallback-grid");
//     if (existingFallback) return existingFallback;

//     var ul2 = document.createElement("ul");
//     ul2.id = "cms-fallback-grid";
//     ul2.className = FALLBACK_GRID_CLASSES;
//     ul2.setAttribute("role", "list");
//     noResultsEl.insertAdjacentElement("afterend", ul2);
//     return ul2;
//   }

//   function buildCardListItem(product, matchedField) {
//     var li = document.createElement("li");
//     li.className = "js-pagination-result cms-extra-result";
//     li.setAttribute("data-product-id", product.id);

//     var imageHtml = product.image
//       ? '<img class="img-fit card__main-image" src="' +
//         escapeHtml(product.image) +
//         '" alt="" loading="lazy" width="300" height="300">'
//       : "";

//     var matchLine = "";
//     if (matchedField) {
//       var label = METAFIELD_LABELS[matchedField] || matchedField;
//       matchLine =
//         '<p class="cms-extra-match text-sm text-theme-light mt-1 mb-0">' +
//         escapeHtml(label) +
//         ": " +
//         escapeHtml(product[matchedField]) +
//         "</p>";
//     }

//     li.innerHTML =
//       '<div class="card card--product h-full flex relative">' +
//       '<div class="card__media relative">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" aria-label="' +
//       escapeHtml(product.title) +
//       '" class="media block relative" style="padding-top: 100%;">' +
//       imageHtml +
//       "</a>" +
//       "</div>" +
//       '<div class="card__info-container flex flex-col flex-auto relative">' +
//       '<div class="card__info w-full">' +
//       '<div class="card__info-inner inline-block w-full">' +
//       '<p class="card__title font-bold mt-1 mb-0">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" class="card-link text-current">' +
//       escapeHtml(product.title) +
//       "</a>" +
//       "</p>" +
//       matchLine +
//       (product.price
//         ? '<div class="card__price theme-money">' + escapeHtml(product.price) + "</div>"
//         : "") +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>";

//     return li;
//   }

//   function getNativeResultIds(grid) {
//     var ids = {};
//     grid.querySelectorAll("[data-product-id]").forEach(function (el) {
//       var id = el.getAttribute("data-product-id");
//       if (id) ids[id] = true;
//     });
//     return ids;
//   }

//   function renderNativeExtraResults(results) {
//     var grid = findResultsGrid();
//     if (!grid) return; // no grid and no "No results found" message found — nothing to do

//     // Remove any previously-injected items before re-adding (progressive
//     // updates re-render the full result set each time).
//     grid.querySelectorAll(".cms-extra-result").forEach(function (el) {
//       el.remove();
//     });

//     // Avoid duplicating a product that the theme's own native search
//     // already placed in the grid (relevant when native results > 0).
//     var nativeIds = getNativeResultIds(grid);

//     var addedAny = false;
//     results.forEach(function (r) {
//       if (nativeIds[r.product.id]) return; // already shown natively, skip
//       grid.appendChild(buildCardListItem(r.product, r.matchedField));
//       addedAny = true;
//     });

//     // We found real matches to show, so any "No results found" message
//     // on the page (whether it's the one above our own fallback grid, or
//     // the theme's top-of-page message shown alongside a real-but-empty
//     // native grid) is now inaccurate — remove it.
//     if (addedAny) {
//       var noResultsEl = findNoResultsElement();
//       if (noResultsEl) noResultsEl.remove();
//     }
//   }

//   /**
//    * If the typed query matches EXACTLY ONE product's SKU (title
//    * matches don't count here — only a SKU/metafield substring match),
//    * redirect the browser to /search?q=<that product's full SKU>. This
//    * hands the query back to Shopify's OWN native search, which already
//    * matches full SKUs correctly — so the resulting page is a normal,
//    * fully-native results page (correct URL, correct markup, no custom
//    * grid needed).
//    *
//    * If MULTIPLE products match (ambiguous — redirecting would hide
//    * the others), this does nothing and the caller falls back to
//    * injecting all matches into a grid instead.
//    *
//    * Returns true if a redirect was triggered (caller should stop).
//    */
//   function attemptSkuRedirect(query) {
//     var q = normalise(query);
//     var results = searchProducts(query, indexState.products, 50);
//     var skuMatches = results.filter(function (r) {
//       return r.matchedField === "sku";
//     });

//     if (skuMatches.length !== 1) return false; // none, or ambiguous — skip

//     var fullSku = skuMatches[0].product.sku;
//     if (!fullSku || normalise(fullSku) === q) return false; // already this exact value — avoid redirect loop

//     var params = new URLSearchParams(window.location.search);
//     params.set("q", fullSku);
//     var newUrl = window.location.pathname + "?" + params.toString();
//     console.log("[CMS] redirecting partial SKU query to full SKU:", query, "->", fullSku);
//     window.location.replace(newUrl);
//     return true;
//   }

//   function initNativeSearchAugmentation() {
//     if (window.location.pathname.indexOf("/search") !== 0) return;

//     var params = new URLSearchParams(window.location.search);
//     var query = params.get("q") || "";
//     if (normalise(query).length < MIN_QUERY_LENGTH) return;

//     var scope = document.getElementById("filter-results");
//     var nativeGrid = scope && scope.querySelector("ul.grid");
//     var nativeHasResults = !!(nativeGrid && nativeGrid.children.length > 0);

//     var redirected = false;

//     startBuildingIndex();

//     function tryRedirectOrRender() {
//       if (redirected) return;

//       // Redirecting to a full SKU only makes sense when native search
//       // found nothing at all — if it already found real results, just
//       // append any additional matches into that same grid instead.
//       if (!nativeHasResults && attemptSkuRedirect(query)) {
//         redirected = true;
//         return;
//       }

//       // Show/merge whatever matches we have so far — for EVERY query,
//       // not just ones where native search found zero results. This
//       // fills in any extra metafield/SKU matches Shopify's own search
//       // missed, right into the existing results grid, deduped against
//       // whatever native already found.
//       var results = searchProducts(query, indexState.products, 10);
//       renderNativeExtraResults(results);
//     }

//     onIndexProgress(tryRedirectOrRender);
//     tryRedirectOrRender();
//   }

//   function getRealTarget(e) {
//     if (typeof e.composedPath === "function") {
//       var path = e.composedPath();
//       if (path && path.length) return path[0];
//     }
//     return e.target;
//   }

//   function init() {
//     console.log("[CMS] custom-metafield-search.js initialised");

//     initNativeSearchAugmentation();

//     document.addEventListener(
//       "focus",
//       function (e) {
//         var target = getRealTarget(e);
//         if (target && target.classList && target.classList.contains("js-search-input")) {
//           startBuildingIndex(); // warm up the index as soon as the box is focused
//         }
//       },
//       true
//     );

//     document.addEventListener("input", function (e) {
//       var input = getRealTarget(e);
//       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
//       var container = ensureContainer(input);
//       handleInputDebounced(input, container);
//     });

//     document.addEventListener("click", function (e) {
//       var target = getRealTarget(e);

//       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
//         var form = sharedContainer && sharedContainer.previousElementSibling;
//         if (form && form.tagName === "FORM") {
//           var inputEl =
//             form.querySelector(".js-search-input") || form.querySelector('input[name="q"]');
//           var typedQuery = inputEl ? inputEl.value : "";

//           // If the typed text resolves to exactly one product's SKU,
//           // send the browser straight to /search?q=<full SKU> instead
//           // of submitting the raw partial text — Shopify's native
//           // search matches the full SKU correctly, so this lands on a
//           // normal, fully-native results page.
//           var skuMatch = null;
//           if (typedQuery) {
//             var results = searchProducts(typedQuery, indexState.products, 50);
//             var skuMatches = results.filter(function (r) {
//               return r.matchedField === "sku";
//             });
//             if (skuMatches.length === 1) skuMatch = skuMatches[0].product.sku;
//           }

//           if (skuMatch && normalise(skuMatch) !== normalise(typedQuery)) {
//             window.location.href = "/search?q=" + encodeURIComponent(skuMatch);
//           } else if (typeof form.requestSubmit === "function") {
//             form.requestSubmit();
//           } else {
//             form.submit();
//           }
//         }
//         return;
//       }

//       if (
//         sharedContainer &&
//         !sharedContainer.hidden &&
//         target !== sharedContainer &&
//         !sharedContainer.contains(target) &&
//         !(target && target.classList && target.classList.contains("js-search-input"))
//       ) {
//         sharedContainer.hidden = true;
//       }
//     });

//     // Enter / form submit: intentionally left as the theme's native/
//     // default behaviour (not intercepted). Only the typing dropdown
//     // above is custom.
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();


// (function () {
//   "use strict";

//   var FEED_URL = "/pages/search-index";
//   var MIN_QUERY_LENGTH = 2;
//   var MAX_RESULTS = 3;
//   var DEBOUNCE_MS = 200;
//   var COLLECTION_BATCH_SIZE = 5;

//   var METAFIELD_LABELS = {
//     sku: "SKU",
//     instrumentation: "Instrumentation",
//     composer: "Composer",
//     arranger: "Arranger",
//     contents_list: "Contents",
//     isbn13: "ISBN13",
//     upc: "UPC",
//     supplier_code: "Supplier Code",
//     label: "Label",
//     tension: "Tension",
//     colour: "Colour",
//     size: "Size",
//     made_in: "Made In"
//   };
//   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

//   /* ---------------------------------------------------------------
//    * Shared, progressively-growing product index for THIS page load.
//    * ------------------------------------------------------------- */
//   var indexState = {
//     products: [], // grows as batches complete
//     byId: {},
//     complete: false,
//     startedAt: null,
//     listeners: [] // functions called after every batch update
//   };

//   function notifyProgress() {
//     indexState.listeners.forEach(function (fn) {
//       try {
//         fn(indexState.products, indexState.complete);
//       } catch (e) {
//         /* ignore listener errors */
//       }
//     });
//   }

//   function onIndexProgress(fn) {
//     indexState.listeners.push(fn);
//     return function unsubscribe() {
//       var i = indexState.listeners.indexOf(fn);
//       if (i !== -1) indexState.listeners.splice(i, 1);
//     };
//   }

//   function fetchJson(url) {
//     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
//     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
//       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
//       return res.json();
//     });
//   }

//   function fetchAllCollectionHandles() {
//     return fetchJson(FEED_URL + "?page=1").then(function (first) {
//       var handles = (first.collections || []).slice();
//       var totalPages = first.pages || 1;
//       if (totalPages <= 1) return handles;

//       var pagePromises = [];
//       for (var p = 2; p <= totalPages; p++) {
//         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
//       }
//       return Promise.all(pagePromises).then(function (rest) {
//         rest.forEach(function (pageData) {
//           handles = handles.concat(pageData.collections || []);
//         });
//         return handles;
//       });
//     });
//   }

//   var buildPromise = null;

//   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
//   // This alone gives broad coverage quickly, including the first 250
//   // products of even the largest collection. Phase 2 then fills in any
//   // remaining pages, processing smaller leftovers first and the
//   // biggest collection's remaining pages last, so early progress
//   // updates aren't blocked waiting on the whole catalog.
//   function startBuildingIndex() {
//     if (buildPromise) return buildPromise;

//     indexState.startedAt = Date.now();
//     console.log("[CMS] building product index (two-phase, progressive)...");

//     buildPromise = (async function () {
//       try {
//         var handles = await fetchAllCollectionHandles();
//         console.log("[CMS] found", handles.length, "collections");

//         function addProducts(products) {
//           products.forEach(function (p) {
//             if (!indexState.byId[p.id]) {
//               indexState.byId[p.id] = p;
//               indexState.products.push(p);
//             }
//           });
//         }

//         // ---- Phase 1: page 1 of every collection ----
//         var needsMore = []; // { handle, pages }
//         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
//           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
//           var batchResults = await Promise.all(
//             batch.map(function (handle) {
//               var base =
//                 "/collections/" +
//                 encodeURIComponent(handle) +
//                 "?view=feed&sort_by=title-ascending";
//               return fetchJson(base + "&page=1")
//                 .then(function (data) {
//                   return { handle: handle, data: data };
//                 })
//                 .catch(function (err) {
//                   console.error("[CMS] failed fetching", handle, "page 1", err);
//                   return null;
//                 });
//             })
//           );

//           batchResults.forEach(function (result) {
//             if (!result) return;
//             addProducts(result.data.products || []);
//             var totalPages = result.data.pages || 1;
//             if (totalPages > 1) {
//               needsMore.push({ handle: result.handle, pages: totalPages });
//             }
//           });

//           notifyProgress(); // fast, broad progress after each small batch
//         }

//         console.log(
//           "[CMS] phase 1 done:",
//           indexState.products.length,
//           "products from page-1 of every collection.",
//           needsMore.length,
//           "collections have more pages."
//         );

//         // ---- Phase 2: remaining pages, smallest leftovers first ----
//         needsMore.sort(function (a, b) {
//           return a.pages - b.pages;
//         });

//         for (var j = 0; j < needsMore.length; j++) {
//           var entry = needsMore[j];
//           var base2 =
//             "/collections/" +
//             encodeURIComponent(entry.handle) +
//             "?view=feed&sort_by=title-ascending";

//           var remainingPagePromises = [];
//           for (var p = 2; p <= entry.pages; p++) {
//             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
//           }

//           try {
//             var pagesData = await Promise.all(remainingPagePromises);
//             pagesData.forEach(function (pageData) {
//               addProducts(pageData.products || []);
//             });
//           } catch (err) {
//             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
//           }

//           notifyProgress(); // update after each collection's remaining pages finish
//         }

//         indexState.complete = true;
//         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
//         console.log(
//           "[CMS] index complete:",
//           indexState.products.length,
//           "products in",
//           seconds + "s"
//         );
//         notifyProgress();
//       } catch (err) {
//         console.error("[CMS] building index FAILED:", err);
//       }
//     })();

//     return buildPromise;
//   }

//   function normalise(str) {
//     return (str || "").toString().toLowerCase().trim();
//   }

//   function alnumOnly(str) {
//     return normalise(str).replace(/[^a-z0-9]/g, "");
//   }

//   function matchProduct(product, q) {
//     var title = normalise(product.title);
//     if (title.indexOf(q) !== -1) {
//       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
//     }

//     if (product.sku) {
//       var skuNorm = alnumOnly(product.sku);
//       var qNorm = alnumOnly(q);
//       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
//         return { field: "sku", score: 90 };
//       }
//     }

//     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
//       var key = METAFIELD_KEYS[i];
//       if (key === "sku") continue;
//       var val = normalise(product[key]);
//       if (val && val.indexOf(q) !== -1) {
//         return { field: key, score: 60 };
//       }
//     }
//     return null;
//   }

//   function searchProducts(query, products, limit) {
//     var q = normalise(query);
//     if (q.length < MIN_QUERY_LENGTH) return [];

//     var results = [];
//     for (var i = 0; i < products.length; i++) {
//       var match = matchProduct(products[i], q);
//       if (match) {
//         results.push({ product: products[i], matchedField: match.field, score: match.score });
//       }
//     }

//     results.sort(function (a, b) {
//       return b.score - a.score;
//     });

//     return results.slice(0, limit || MAX_RESULTS);
//   }

//   function escapeHtml(str) {
//     var div = document.createElement("div");
//     div.textContent = str == null ? "" : String(str);
//     return div.innerHTML;
//   }

//   function renderDropdown(container, results, query, stillLoading) {
//     if (!results.length) {
//       if (stillLoading) {
//         container.innerHTML =
//           '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//       } else {
//         container.innerHTML =
//           '<div class="cms-no-results">No results for &ldquo;' +
//           escapeHtml(query) +
//           "&rdquo;</div>" +
//           '<button type="button" class="cms-view-all-btn">View all results</button>';
//       }
//       container.hidden = false;
//       return;
//     }

//     var html = '<ul class="cms-results-list" role="listbox">';
//     results.forEach(function (r) {
//       var p = r.product;
//       var matchLine = "";
//       if (r.matchedField) {
//         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
//         matchLine =
//           '<span class="cms-result-match">' +
//           escapeHtml(label) +
//           ": " +
//           escapeHtml(p[r.matchedField]) +
//           "</span>";
//       }
//       html +=
//         '<li class="cms-result-item" role="option">' +
//         '<a href="' +
//         escapeHtml(p.url) +
//         '" class="cms-result-link">' +
//         (p.image
//           ? '<img class="cms-result-image" src="' +
//             escapeHtml(p.image) +
//             '" alt="" loading="lazy" width="48" height="48">'
//           : '<span class="cms-result-image cms-result-image--empty"></span>') +
//         '<span class="cms-result-text">' +
//         '<span class="cms-result-title">' +
//         escapeHtml(p.title) +
//         "</span>" +
//         matchLine +
//         "</span>" +
//         "</a>" +
//         "</li>";
//     });
//     html += "</ul>";

//     html += '<button type="button" class="cms-view-all-btn">View all results</button>';

//     container.innerHTML = html;
//     container.hidden = false;
//   }

//   function debounce(fn, wait) {
//     var timer = null;
//     return function () {
//       var args = arguments;
//       var ctx = this;
//       clearTimeout(timer);
//       timer = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   var sharedContainer = null;

//   function ensureContainer(input) {
//     if (!sharedContainer) {
//       sharedContainer = document.createElement("div");
//       sharedContainer.id = "cms-metafield-results-shared";
//       sharedContainer.className = "cms-metafield-results";
//       sharedContainer.hidden = true;
//     }
//     var form = input.closest("form");
//     var anchor = form || input;
//     if (sharedContainer.previousElementSibling !== anchor) {
//       anchor.insertAdjacentElement("afterend", sharedContainer);
//     }
//     return sharedContainer;
//   }

//   var activeUnsubscribe = null;

//   function runDropdownSearch(input, container) {
//     var query = input.value;

//     if (activeUnsubscribe) {
//       activeUnsubscribe();
//       activeUnsubscribe = null;
//     }

//     if (normalise(query).length < MIN_QUERY_LENGTH) {
//       container.hidden = true;
//       container.innerHTML = "";
//       return;
//     }

//     // Show a loading state immediately.
//     container.innerHTML =
//       '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//     container.hidden = false;

//     startBuildingIndex();

//     function renderNow() {
//       // Always read the CURRENT input value, in case the user kept
//       // typing while a batch was loading — avoids showing stale results.
//       var currentQuery = input.value;
//       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
//       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
//       renderDropdown(container, results, currentQuery, !indexState.complete);
//     }

//     renderNow(); // render with whatever's loaded so far, immediately
//     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
//   }

//   var handleInputDebounced = debounce(function (input, container) {
//     runDropdownSearch(input, container);
//   }, DEBOUNCE_MS);

//   /* ---------------------------------------------------------------
//    * Inject extra matches (metafields/SKU) directly into the native
//    * /search results grid (<ul class="grid"> inside #filter-results),
//    * as real <li> items using the theme's own card classes — so they
//    * look like normal results, not a separate section.
//    *
//    * Two scenarios are handled:
//    *   1. Theme found >=1 native result: #filter-results and its
//    *      ul.grid already exist — we just append into that same grid.
//    *   2. Theme found 0 native results: many themes render NO
//    *      #filter-results container at all in this case, just a
//    *      "No results found" message. We locate that message and
//    *      build our own grid directly after it, then remove the
//    *      message once we have real matches to show — so the page
//    *      never shows both "No results found" and actual results.
//    * ------------------------------------------------------------- */
//   function findNoResultsElement() {
//     var candidates = document.querySelectorAll("body *");
//     for (var i = 0; i < candidates.length; i++) {
//       var el = candidates[i];
//       // Match on the smallest element containing the phrase, so we
//       // don't grab a huge wrapper (e.g. <body> or <main>) by mistake.
//       if (el.children.length === 0 && /no results found/i.test(el.textContent || "")) {
//         return el;
//       }
//     }
//     return null;
//   }

//   // Exact grid classes this store's theme (Shopify "Enterprise") uses
//   // for its own native results grid — verified against a real,
//   // working native search results page's HTML on this store.
//   var CONFIRMED_GRID_CLASSES = "grid mb-8 md:mb-12 grid-cols-1 sm:grid-cols-3 gap-x-theme gap-y-10";

//   function findResultsGrid() {
//     var scope = document.getElementById("filter-results");
//     if (scope) {
//       var existing = scope.querySelector("ul.grid, ul[role='list']");
//       if (existing) return existing;

//       // #filter-results exists but has no grid yet (0 native results
//       // on this theme) — build one using the confirmed real classes.
//       var ul = document.createElement("ul");
//       ul.className = CONFIRMED_GRID_CLASSES;
//       ul.setAttribute("role", "list");
//       scope.appendChild(ul);
//       return ul;
//     }

//     // Fallback: theme renders nothing resembling #filter-results at
//     // all when native search returns 0 results — just a "No results
//     // found" message. Build the grid right after that message.
//     var noResultsEl = findNoResultsElement();
//     if (!noResultsEl) return null;

//     var existingFallback = document.getElementById("cms-fallback-grid");
//     if (existingFallback) return existingFallback;

//     var ul2 = document.createElement("ul");
//     ul2.id = "cms-fallback-grid";
//     ul2.className = CONFIRMED_GRID_CLASSES;
//     ul2.setAttribute("role", "list");
//     noResultsEl.insertAdjacentElement("afterend", ul2);
//     return ul2;
//   }

//   // Exact card markup this store's theme renders for each product in
//   // search results — verified against the same real page HTML above
//   // (a <li class="js-pagination-result"> containing a <product-card>
//   // with card__media, card__info-container, card__title, price, etc.)
//   var PLACEHOLDER_SVG =
//     '<svg class="media__placeholder img-fit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">' +
//     '<path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>' +
//     "</svg>";

//   function buildCardListItem(product, matchedField) {
//     var li = document.createElement("li");
//     li.className = "js-pagination-result cms-extra-result";

//     var mediaContent = product.image
//       ? '<img class="img-fit" src="' +
//         escapeHtml(product.image) +
//         '" alt="" loading="lazy" width="300" height="300">'
//       : PLACEHOLDER_SVG;

//     var matchLine = "";
//     if (matchedField) {
//       var label = METAFIELD_LABELS[matchedField] || matchedField;
//       matchLine =
//         '<p class="cms-extra-match mb-0 text-sm text-theme-light">' +
//         escapeHtml(label) +
//         ": " +
//         escapeHtml(product[matchedField]) +
//         "</p>";
//     }

//     li.innerHTML =
//       '<product-card class="card card--product h-full card--no-lines relative flex">' +
//       '<div class="card__media relative">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" aria-label="' +
//       escapeHtml(product.title || "") +
//       '" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">' +
//       mediaContent +
//       "</a>" +
//       "</div>" +
//       '<div class="card__info-container flex flex-col flex-auto relative">' +
//       '<div class="card__info w-full">' +
//       '<div class="card__info-inner flex flex-col h-full w-full">' +
//       (product.vendor
//         ? '<p class="card__vendor mb-0 text-sm text-theme-light">' + escapeHtml(product.vendor) + "</p>"
//         : "") +
//       '<p class="card__title font-bold mt-1 mb-0">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" class="card-link text-current js-prod-link">' +
//       escapeHtml(product.title || "") +
//       "</a>" +
//       "</p>" +
//       matchLine +
//       '<div class="flex grow items-end">' +
//       '<div class="price price--bottom">' +
//       '<div class="price__default">' +
//       '<strong class="price__current">' +
//       (product.price ? escapeHtml(product.price) : "") +
//       "</strong>" +
//       '<s class="price__was"></s>' +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</product-card>";

//     return li;
//   }

//   function toPathname(url) {
//     try {
//       return new URL(url, window.location.origin).pathname;
//     } catch (e) {
//       return url;
//     }
//   }

//   function getNativeResultIds(grid) {
//     // Native cards on this theme carry no data-product-id, so dedupe
//     // by the product URL path instead — reliably present on both
//     // native and our own injected cards.
//     var paths = {};
//     grid.querySelectorAll("a[href]").forEach(function (a) {
//       var path = toPathname(a.getAttribute("href"));
//       if (path) paths[path] = true;
//     });
//     return paths;
//   }

//   function renderNativeExtraResults(results) {
//     var grid = findResultsGrid();
//     if (!grid) return; // no grid and no "No results found" message found — nothing to do

//     // Remove any previously-injected items before re-adding (progressive
//     // updates re-render the full result set each time).
//     grid.querySelectorAll(".cms-extra-result").forEach(function (el) {
//       el.remove();
//     });

//     // Avoid duplicating a product that the theme's own native search
//     // already placed in the grid (relevant when native results > 0).
//     var nativePaths = getNativeResultIds(grid);

//     var addedAny = false;
//     results.forEach(function (r) {
//       if (nativePaths[toPathname(r.product.url)]) return; // already shown natively, skip
//       grid.appendChild(buildCardListItem(r.product, r.matchedField));
//       addedAny = true;
//     });

//     // We found real matches to show, so any "No results found" message
//     // on the page (whether it's the one above our own fallback grid, or
//     // the theme's top-of-page message shown alongside a real-but-empty
//     // native grid) is now inaccurate — remove it.
//     if (addedAny) {
//       var noResultsEl = findNoResultsElement();
//       if (noResultsEl) noResultsEl.remove();
//     }
//   }

//   /**
//    * If the typed query matches EXACTLY ONE product's SKU (title
//    * matches don't count here — only a SKU/metafield substring match),
//    * redirect the browser to /search?q=<that product's full SKU>. This
//    * hands the query back to Shopify's OWN native search, which already
//    * matches full SKUs correctly — so the resulting page is a normal,
//    * fully-native results page (correct URL, correct markup, no custom
//    * grid needed).
//    *
//    * If MULTIPLE products match (ambiguous — redirecting would hide
//    * the others), this does nothing and the caller falls back to
//    * injecting all matches into a grid instead.
//    *
//    * Returns true if a redirect was triggered (caller should stop).
//    */
//   function attemptSkuRedirect(query) {
//     var q = normalise(query);
//     var results = searchProducts(query, indexState.products, 50);
//     var skuMatches = results.filter(function (r) {
//       return r.matchedField === "sku";
//     });

//     if (skuMatches.length !== 1) return false; // none, or ambiguous — skip

//     var fullSku = skuMatches[0].product.sku;
//     if (!fullSku || normalise(fullSku) === q) return false; // already this exact value — avoid redirect loop

//     var params = new URLSearchParams(window.location.search);
//     params.set("q", fullSku);
//     var newUrl = window.location.pathname + "?" + params.toString();
//     console.log("[CMS] redirecting partial SKU query to full SKU:", query, "->", fullSku);
//     window.location.replace(newUrl);
//     return true;
//   }

//   function initNativeSearchAugmentation() {
//     if (window.location.pathname.indexOf("/search") !== 0) return;

//     var params = new URLSearchParams(window.location.search);
//     var query = params.get("q") || "";
//     if (normalise(query).length < MIN_QUERY_LENGTH) return;

//     var scope = document.getElementById("filter-results");
//     var nativeGrid = scope && scope.querySelector("ul.grid");
//     var nativeHasResults = !!(nativeGrid && nativeGrid.children.length > 0);

//     var redirected = false;

//     startBuildingIndex();

//     function tryRedirectOrRender() {
//       if (redirected) return;

//       // Redirecting to a full SKU only makes sense when native search
//       // found nothing at all — if it already found real results, just
//       // append any additional matches into that same grid instead.
//       if (!nativeHasResults && attemptSkuRedirect(query)) {
//         redirected = true;
//         return;
//       }

//       // Show/merge whatever matches we have so far — for EVERY query,
//       // not just ones where native search found zero results. This
//       // fills in any extra metafield/SKU matches Shopify's own search
//       // missed, right into the existing results grid, deduped against
//       // whatever native already found.
//       var results = searchProducts(query, indexState.products, 10);
//       renderNativeExtraResults(results);
//     }

//     onIndexProgress(tryRedirectOrRender);
//     tryRedirectOrRender();
//   }

//   function getRealTarget(e) {
//     if (typeof e.composedPath === "function") {
//       var path = e.composedPath();
//       if (path && path.length) return path[0];
//     }
//     return e.target;
//   }

//   function init() {
//     console.log("[CMS] custom-metafield-search.js initialised");

//     initNativeSearchAugmentation();

//     document.addEventListener(
//       "focus",
//       function (e) {
//         var target = getRealTarget(e);
//         if (target && target.classList && target.classList.contains("js-search-input")) {
//           startBuildingIndex(); // warm up the index as soon as the box is focused
//         }
//       },
//       true
//     );

//     document.addEventListener("input", function (e) {
//       var input = getRealTarget(e);
//       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
//       var container = ensureContainer(input);
//       handleInputDebounced(input, container);
//     });

//     document.addEventListener("click", function (e) {
//       var target = getRealTarget(e);

//       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
//         var form = sharedContainer && sharedContainer.previousElementSibling;
//         if (form && form.tagName === "FORM") {
//           var inputEl =
//             form.querySelector(".js-search-input") || form.querySelector('input[name="q"]');
//           var typedQuery = inputEl ? inputEl.value : "";

//           // If the typed text resolves to exactly one product's SKU,
//           // send the browser straight to /search?q=<full SKU> instead
//           // of submitting the raw partial text — Shopify's native
//           // search matches the full SKU correctly, so this lands on a
//           // normal, fully-native results page.
//           var skuMatch = null;
//           if (typedQuery) {
//             var results = searchProducts(typedQuery, indexState.products, 50);
//             var skuMatches = results.filter(function (r) {
//               return r.matchedField === "sku";
//             });
//             if (skuMatches.length === 1) skuMatch = skuMatches[0].product.sku;
//           }

//           if (skuMatch && normalise(skuMatch) !== normalise(typedQuery)) {
//             window.location.href = "/search?q=" + encodeURIComponent(skuMatch);
//           } else if (typeof form.requestSubmit === "function") {
//             form.requestSubmit();
//           } else {
//             form.submit();
//           }
//         }
//         return;
//       }

//       if (
//         sharedContainer &&
//         !sharedContainer.hidden &&
//         target !== sharedContainer &&
//         !sharedContainer.contains(target) &&
//         !(target && target.classList && target.classList.contains("js-search-input"))
//       ) {
//         sharedContainer.hidden = true;
//       }
//     });

//     // Enter / form submit: intentionally left as the theme's native/
//     // default behaviour (not intercepted). Only the typing dropdown
//     // above is custom.
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();


// (function () {
//   "use strict";

//   var FEED_URL = "/pages/search-index";
//   var MIN_QUERY_LENGTH = 2;
//   var MAX_RESULTS = 3;
//   var DEBOUNCE_MS = 200;
//   var COLLECTION_BATCH_SIZE = 5;

//   var METAFIELD_LABELS = {
//     sku: "SKU",
//     instrumentation: "Instrumentation",
//     composer: "Composer",
//     arranger: "Arranger",
//     contents_list: "Contents",
//     isbn13: "ISBN13",
//     upc: "UPC",
//     supplier_code: "Supplier Code",
//     label: "Label",
//     tension: "Tension",
//     colour: "Colour",
//     size: "Size",
//     made_in: "Made In"
//   };
//   var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

//   /* ---------------------------------------------------------------
//    * Shared, progressively-growing product index for THIS page load.
//    * ------------------------------------------------------------- */
//   var indexState = {
//     products: [], // grows as batches complete
//     byId: {},
//     complete: false,
//     startedAt: null,
//     listeners: [] // functions called after every batch update
//   };

//   function notifyProgress() {
//     indexState.listeners.forEach(function (fn) {
//       try {
//         fn(indexState.products, indexState.complete);
//       } catch (e) {
//         /* ignore listener errors */
//       }
//     });
//   }

//   function onIndexProgress(fn) {
//     indexState.listeners.push(fn);
//     return function unsubscribe() {
//       var i = indexState.listeners.indexOf(fn);
//       if (i !== -1) indexState.listeners.splice(i, 1);
//     };
//   }

//   function fetchJson(url) {
//     var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
//     return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
//       if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
//       return res.json();
//     });
//   }

//   function fetchAllCollectionHandles() {
//     return fetchJson(FEED_URL + "?page=1").then(function (first) {
//       var handles = (first.collections || []).slice();
//       var totalPages = first.pages || 1;
//       if (totalPages <= 1) return handles;

//       var pagePromises = [];
//       for (var p = 2; p <= totalPages; p++) {
//         pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
//       }
//       return Promise.all(pagePromises).then(function (rest) {
//         rest.forEach(function (pageData) {
//           handles = handles.concat(pageData.collections || []);
//         });
//         return handles;
//       });
//     });
//   }

//   var buildPromise = null;

//   // Phase 1: fetch just page 1 of every collection (fast, lightweight).
//   // This alone gives broad coverage quickly, including the first 250
//   // products of even the largest collection. Phase 2 then fills in any
//   // remaining pages, processing smaller leftovers first and the
//   // biggest collection's remaining pages last, so early progress
//   // updates aren't blocked waiting on the whole catalog.
//   function startBuildingIndex() {
//     if (buildPromise) return buildPromise;

//     indexState.startedAt = Date.now();
//     console.log("[CMS] building product index (two-phase, progressive)...");

//     buildPromise = (async function () {
//       try {
//         var handles = await fetchAllCollectionHandles();
//         console.log("[CMS] found", handles.length, "collections");

//         function addProducts(products) {
//           products.forEach(function (p) {
//             if (!indexState.byId[p.id]) {
//               indexState.byId[p.id] = p;
//               indexState.products.push(p);
//             }
//           });
//         }

//         // ---- Phase 1: page 1 of every collection ----
//         var needsMore = []; // { handle, pages }
//         for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
//           var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
//           var batchResults = await Promise.all(
//             batch.map(function (handle) {
//               var base =
//                 "/collections/" +
//                 encodeURIComponent(handle) +
//                 "?view=feed&sort_by=title-ascending";
//               return fetchJson(base + "&page=1")
//                 .then(function (data) {
//                   return { handle: handle, data: data };
//                 })
//                 .catch(function (err) {
//                   console.error("[CMS] failed fetching", handle, "page 1", err);
//                   return null;
//                 });
//             })
//           );

//           batchResults.forEach(function (result) {
//             if (!result) return;
//             addProducts(result.data.products || []);
//             var totalPages = result.data.pages || 1;
//             if (totalPages > 1) {
//               needsMore.push({ handle: result.handle, pages: totalPages });
//             }
//           });

//           notifyProgress(); // fast, broad progress after each small batch
//         }

//         console.log(
//           "[CMS] phase 1 done:",
//           indexState.products.length,
//           "products from page-1 of every collection.",
//           needsMore.length,
//           "collections have more pages."
//         );

//         // ---- Phase 2: remaining pages, smallest leftovers first ----
//         needsMore.sort(function (a, b) {
//           return a.pages - b.pages;
//         });

//         for (var j = 0; j < needsMore.length; j++) {
//           var entry = needsMore[j];
//           var base2 =
//             "/collections/" +
//             encodeURIComponent(entry.handle) +
//             "?view=feed&sort_by=title-ascending";

//           var remainingPagePromises = [];
//           for (var p = 2; p <= entry.pages; p++) {
//             remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
//           }

//           try {
//             var pagesData = await Promise.all(remainingPagePromises);
//             pagesData.forEach(function (pageData) {
//               addProducts(pageData.products || []);
//             });
//           } catch (err) {
//             console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
//           }

//           notifyProgress(); // update after each collection's remaining pages finish
//         }

//         indexState.complete = true;
//         var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
//         console.log(
//           "[CMS] index complete:",
//           indexState.products.length,
//           "products in",
//           seconds + "s"
//         );
//         notifyProgress();
//       } catch (err) {
//         console.error("[CMS] building index FAILED:", err);
//       }
//     })();

//     return buildPromise;
//   }

//   function normalise(str) {
//     return (str || "").toString().toLowerCase().trim();
//   }

//   function alnumOnly(str) {
//     return normalise(str).replace(/[^a-z0-9]/g, "");
//   }

//   function matchProduct(product, q) {
//     var title = normalise(product.title);
//     if (title.indexOf(q) !== -1) {
//       return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
//     }

//     if (product.sku) {
//       var skuNorm = alnumOnly(product.sku);
//       var qNorm = alnumOnly(q);
//       if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
//         return { field: "sku", score: 90 };
//       }
//     }

//     for (var i = 0; i < METAFIELD_KEYS.length; i++) {
//       var key = METAFIELD_KEYS[i];
//       if (key === "sku") continue;
//       var val = normalise(product[key]);
//       if (val && val.indexOf(q) !== -1) {
//         return { field: key, score: 60 };
//       }
//     }
//     return null;
//   }

//   function searchProducts(query, products, limit) {
//     var q = normalise(query);
//     if (q.length < MIN_QUERY_LENGTH) return [];

//     var results = [];
//     for (var i = 0; i < products.length; i++) {
//       var match = matchProduct(products[i], q);
//       if (match) {
//         results.push({ product: products[i], matchedField: match.field, score: match.score });
//       }
//     }

//     results.sort(function (a, b) {
//       return b.score - a.score;
//     });

//     return results.slice(0, limit || MAX_RESULTS);
//   }

//   function escapeHtml(str) {
//     var div = document.createElement("div");
//     div.textContent = str == null ? "" : String(str);
//     return div.innerHTML;
//   }

//   function renderDropdown(container, results, query, stillLoading) {
//     if (!results.length) {
//       if (stillLoading) {
//         container.innerHTML =
//           '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//       } else {
//         container.innerHTML =
//           '<div class="cms-no-results">No results for &ldquo;' +
//           escapeHtml(query) +
//           "&rdquo;</div>" +
//           '<button type="button" class="cms-view-all-btn">View all results</button>';
//       }
//       container.hidden = false;
//       return;
//     }

//     var html = '<ul class="cms-results-list" role="listbox">';
//     results.forEach(function (r) {
//       var p = r.product;
//       var matchLine = "";
//       if (r.matchedField) {
//         var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
//         matchLine =
//           '<span class="cms-result-match">' +
//           escapeHtml(label) +
//           ": " +
//           escapeHtml(p[r.matchedField]) +
//           "</span>";
//       }
//       html +=
//         '<li class="cms-result-item" role="option">' +
//         '<a href="' +
//         escapeHtml(p.url) +
//         '" class="cms-result-link">' +
//         (p.image
//           ? '<img class="cms-result-image" src="' +
//             escapeHtml(p.image) +
//             '" alt="" loading="lazy" width="48" height="48">'
//           : '<span class="cms-result-image cms-result-image--empty"></span>') +
//         '<span class="cms-result-text">' +
//         '<span class="cms-result-title">' +
//         escapeHtml(p.title) +
//         "</span>" +
//         matchLine +
//         "</span>" +
//         "</a>" +
//         "</li>";
//     });
//     html += "</ul>";

//     html += '<button type="button" class="cms-view-all-btn">View all results</button>';

//     container.innerHTML = html;
//     container.hidden = false;
//   }

//   function debounce(fn, wait) {
//     var timer = null;
//     return function () {
//       var args = arguments;
//       var ctx = this;
//       clearTimeout(timer);
//       timer = setTimeout(function () {
//         fn.apply(ctx, args);
//       }, wait);
//     };
//   }

//   var sharedContainer = null;

//   function ensureContainer(input) {
//     if (!sharedContainer) {
//       sharedContainer = document.createElement("div");
//       sharedContainer.id = "cms-metafield-results-shared";
//       sharedContainer.className = "cms-metafield-results";
//       sharedContainer.hidden = true;
//     }
//     var form = input.closest("form");
//     var anchor = form || input;
//     if (sharedContainer.previousElementSibling !== anchor) {
//       anchor.insertAdjacentElement("afterend", sharedContainer);
//     }
//     return sharedContainer;
//   }

//   var activeUnsubscribe = null;

//   function runDropdownSearch(input, container) {
//     var query = input.value;

//     if (activeUnsubscribe) {
//       activeUnsubscribe();
//       activeUnsubscribe = null;
//     }

//     if (normalise(query).length < MIN_QUERY_LENGTH) {
//       container.hidden = true;
//       container.innerHTML = "";
//       return;
//     }

//     // Show a loading state immediately.
//     container.innerHTML =
//       '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
//     container.hidden = false;

//     startBuildingIndex();

//     function renderNow() {
//       // Always read the CURRENT input value, in case the user kept
//       // typing while a batch was loading — avoids showing stale results.
//       var currentQuery = input.value;
//       if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
//       var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
//       renderDropdown(container, results, currentQuery, !indexState.complete);
//     }

//     renderNow(); // render with whatever's loaded so far, immediately
//     activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
//   }

//   var handleInputDebounced = debounce(function (input, container) {
//     runDropdownSearch(input, container);
//   }, DEBOUNCE_MS);

//   /* ---------------------------------------------------------------
//    * Inject extra matches (metafields/SKU) directly into the native
//    * /search results grid (<ul class="grid"> inside #filter-results),
//    * as real <li> items using the theme's own card classes — so they
//    * look like normal results, not a separate section.
//    *
//    * Two scenarios are handled:
//    *   1. Theme found >=1 native result: #filter-results and its
//    *      ul.grid already exist — we just append into that same grid.
//    *   2. Theme found 0 native results: many themes render NO
//    *      #filter-results container at all in this case, just a
//    *      "No results found" message. We locate that message and
//    *      build our own grid directly after it, then remove the
//    *      message once we have real matches to show — so the page
//    *      never shows both "No results found" and actual results.
//    * ------------------------------------------------------------- */
//   function findNoResultsElement() {
//     var candidates = document.querySelectorAll("body *");
//     for (var i = 0; i < candidates.length; i++) {
//       var el = candidates[i];
//       // Match on the smallest element containing the phrase, so we
//       // don't grab a huge wrapper (e.g. <body> or <main>) by mistake.
//       if (el.children.length === 0 && /no results found/i.test(el.textContent || "")) {
//         return el;
//       }
//     }
//     return null;
//   }

//   // For OUR OWN injected grid (used only when native search found 0
//   // results and no real grid exists yet), we set layout via inline
//   // styles rather than the theme's Tailwind utility classes. Utility
//   // classes like "grid-cols-1 sm:grid-cols-3" only reliably apply when
//   // the THEME'S OWN Liquid server-renders them (as with a real 2-result
//   // page) — on an element we create purely in JS, this combination was
//   // found NOT to take effect (cards collapsed into a broken single
//   // column). Inline styles have no such dependency and always work.
//   function applyFallbackGridStyles(ul) {
//     ul.style.display = "grid";
//     ul.style.gridTemplateColumns = "repeat(auto-fill, minmax(220px, 1fr))";
//     ul.style.gap = "24px";
//     ul.style.marginBottom = "32px";
//     ul.style.listStyle = "none";
//     ul.style.padding = "0";
//   }

//   // Resolved ONCE per page load and reused for every progressive
//   // re-render (as more of the product index loads), so we never end up
//   // creating a second grid element in a different spot mid-way through
//   // — which previously caused a stray duplicate card to appear outside
//   // the real results area.
//   var targetGridEl = null;

//   function findResultsGrid() {
//     if (targetGridEl && document.body.contains(targetGridEl)) return targetGridEl;

//     var scope = document.getElementById("filter-results");
//     if (scope) {
//       var existing = scope.querySelector("ul.grid, ul[role='list']");
//       if (existing) {
//         targetGridEl = existing;
//         return targetGridEl;
//       }

//       // #filter-results exists but has no grid yet (0 native results
//       // on this theme) — build one with guaranteed inline grid styles.
//       var ul = document.createElement("ul");
//       ul.setAttribute("role", "list");
//       applyFallbackGridStyles(ul);
//       scope.appendChild(ul);
//       targetGridEl = ul;
//       return targetGridEl;
//     }

//     // Fallback: theme renders nothing resembling #filter-results at
//     // all when native search returns 0 results — just a "No results
//     // found" message. Build the grid right after that message.
//     var existingFallback = document.getElementById("cms-fallback-grid");
//     if (existingFallback) {
//       targetGridEl = existingFallback;
//       return targetGridEl;
//     }

//     var noResultsEl = findNoResultsElement();
//     if (!noResultsEl) return null;

//     var ul2 = document.createElement("ul");
//     ul2.id = "cms-fallback-grid";
//     ul2.setAttribute("role", "list");
//     applyFallbackGridStyles(ul2);
//     noResultsEl.insertAdjacentElement("afterend", ul2);
//     targetGridEl = ul2;
//     return targetGridEl;
//   }

//   // Exact card markup this store's theme renders for each product in
//   // search results — verified against the same real page HTML above
//   // (a <li class="js-pagination-result"> containing a <product-card>
//   // with card__media, card__info-container, card__title, price, etc.)
//   var PLACEHOLDER_SVG =
//     '<svg class="media__placeholder img-fit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">' +
//     '<path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>' +
//     "</svg>";

//   function buildCardListItem(product, matchedField) {
//     var li = document.createElement("li");
//     li.className = "js-pagination-result cms-extra-result";

//     var mediaContent = product.image
//       ? '<img class="img-fit" src="' +
//         escapeHtml(product.image) +
//         '" alt="" loading="lazy" width="300" height="300">'
//       : PLACEHOLDER_SVG;

//     var matchLine = "";
//     if (matchedField) {
//       var label = METAFIELD_LABELS[matchedField] || matchedField;
//       matchLine =
//         '<p class="cms-extra-match mb-0 text-sm text-theme-light">' +
//         escapeHtml(label) +
//         ": " +
//         escapeHtml(product[matchedField]) +
//         "</p>";
//     }

//     li.innerHTML =
//       '<product-card class="card card--product h-full card--no-lines relative flex">' +
//       '<div class="card__media relative">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" aria-label="' +
//       escapeHtml(product.title || "") +
//       '" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">' +
//       mediaContent +
//       "</a>" +
//       "</div>" +
//       '<div class="card__info-container flex flex-col flex-auto relative">' +
//       '<div class="card__info w-full">' +
//       '<div class="card__info-inner flex flex-col h-full w-full">' +
//       (product.vendor
//         ? '<p class="card__vendor mb-0 text-sm text-theme-light">' + escapeHtml(product.vendor) + "</p>"
//         : "") +
//       '<p class="card__title font-bold mt-1 mb-0">' +
//       '<a href="' +
//       escapeHtml(product.url) +
//       '" class="card-link text-current js-prod-link">' +
//       escapeHtml(product.title || "") +
//       "</a>" +
//       "</p>" +
//       matchLine +
//       '<div class="flex grow items-end">' +
//       '<div class="price price--bottom">' +
//       '<div class="price__default">' +
//       '<strong class="price__current">' +
//       (product.price ? escapeHtml(product.price) : "") +
//       "</strong>" +
//       '<s class="price__was"></s>' +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</div>" +
//       "</product-card>";

//     return li;
//   }

//   function toPathname(url) {
//     try {
//       return new URL(url, window.location.origin).pathname;
//     } catch (e) {
//       return url;
//     }
//   }

//   function getNativeResultIds(grid) {
//     // Native cards on this theme carry no data-product-id, so dedupe
//     // by the product URL path instead — reliably present on both
//     // native and our own injected cards.
//     var paths = {};
//     grid.querySelectorAll("a[href]").forEach(function (a) {
//       var path = toPathname(a.getAttribute("href"));
//       if (path) paths[path] = true;
//     });
//     return paths;
//   }

//   function renderNativeExtraResults(results) {
//     var grid = findResultsGrid();
//     if (!grid) return; // no grid and no "No results found" message found — nothing to do

//     // Remove any previously-injected items before re-adding (progressive
//     // updates re-render the full result set each time).
//     grid.querySelectorAll(".cms-extra-result").forEach(function (el) {
//       el.remove();
//     });

//     // Avoid duplicating a product that the theme's own native search
//     // already placed in the grid (relevant when native results > 0).
//     var nativePaths = getNativeResultIds(grid);

//     var addedAny = false;
//     results.forEach(function (r) {
//       if (nativePaths[toPathname(r.product.url)]) return; // already shown natively, skip
//       grid.appendChild(buildCardListItem(r.product, r.matchedField));
//       addedAny = true;
//     });

//     // We found real matches to show, so any "No results found" message
//     // on the page (whether it's the one above our own fallback grid, or
//     // the theme's top-of-page message shown alongside a real-but-empty
//     // native grid) is now inaccurate — remove it.
//     if (addedAny) {
//       var noResultsEl = findNoResultsElement();
//       if (noResultsEl) noResultsEl.remove();
//     }
//   }

//   /**
//    * If the typed query matches EXACTLY ONE product's SKU (title
//    * matches don't count here — only a SKU/metafield substring match),
//    * redirect the browser to /search?q=<that product's full SKU>. This
//    * hands the query back to Shopify's OWN native search, which already
//    * matches full SKUs correctly — so the resulting page is a normal,
//    * fully-native results page (correct URL, correct markup, no custom
//    * grid needed).
//    *
//    * If MULTIPLE products match (ambiguous — redirecting would hide
//    * the others), this does nothing and the caller falls back to
//    * injecting all matches into a grid instead.
//    *
//    * Returns true if a redirect was triggered (caller should stop).
//    */
//   function attemptSkuRedirect(query) {
//     var q = normalise(query);
//     var results = searchProducts(query, indexState.products, 50);
//     var skuMatches = results.filter(function (r) {
//       return r.matchedField === "sku";
//     });

//     if (skuMatches.length !== 1) return false; // none, or ambiguous — skip

//     var fullSku = skuMatches[0].product.sku;
//     if (!fullSku || normalise(fullSku) === q) return false; // already this exact value — avoid redirect loop

//     var params = new URLSearchParams(window.location.search);
//     params.set("q", fullSku);
//     var newUrl = window.location.pathname + "?" + params.toString();
//     console.log("[CMS] redirecting partial SKU query to full SKU:", query, "->", fullSku);
//     window.location.replace(newUrl);
//     return true;
//   }

//   function initNativeSearchAugmentation() {
//     if (window.location.pathname.indexOf("/search") !== 0) return;

//     var params = new URLSearchParams(window.location.search);
//     var query = params.get("q") || "";
//     if (normalise(query).length < MIN_QUERY_LENGTH) return;

//     var scope = document.getElementById("filter-results");
//     var nativeGrid = scope && scope.querySelector("ul.grid");
//     var nativeHasResults = !!(nativeGrid && nativeGrid.children.length > 0);

//     var redirected = false;

//     startBuildingIndex();

//     function tryRedirectOrRender() {
//       if (redirected) return;

//       // IMPORTANT: only decide to redirect once the FULL product index
//       // has finished loading. Deciding earlier (mid-way through the
//       // progressive load) risks seeing only 1 match right now when 2
//       // more matching products haven't been indexed yet — which would
//       // wrongly redirect away before the other matches are found.
//       if (!nativeHasResults && indexState.complete && attemptSkuRedirect(query)) {
//         redirected = true;
//         return;
//       }

//       // Show/merge whatever matches we have so far — for EVERY query,
//       // not just ones where native search found zero results. This
//       // fills in any extra metafield/SKU matches Shopify's own search
//       // missed, right into the existing results grid, deduped against
//       // whatever native already found.
//       var results = searchProducts(query, indexState.products, 10);
//       renderNativeExtraResults(results);
//     }

//     onIndexProgress(tryRedirectOrRender);
//     tryRedirectOrRender();
//   }

//   function getRealTarget(e) {
//     if (typeof e.composedPath === "function") {
//       var path = e.composedPath();
//       if (path && path.length) return path[0];
//     }
//     return e.target;
//   }

//   function init() {
//     console.log("[CMS] custom-metafield-search.js initialised");

//     initNativeSearchAugmentation();

//     document.addEventListener(
//       "focus",
//       function (e) {
//         var target = getRealTarget(e);
//         if (target && target.classList && target.classList.contains("js-search-input")) {
//           startBuildingIndex(); // warm up the index as soon as the box is focused
//         }
//       },
//       true
//     );

//     document.addEventListener("input", function (e) {
//       var input = getRealTarget(e);
//       if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
//       var container = ensureContainer(input);
//       handleInputDebounced(input, container);
//     });

//     document.addEventListener("click", function (e) {
//       var target = getRealTarget(e);

//       if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
//         var form = sharedContainer && sharedContainer.previousElementSibling;
//         if (form && form.tagName === "FORM") {
//           var inputEl =
//             form.querySelector(".js-search-input") || form.querySelector('input[name="q"]');
//           var typedQuery = inputEl ? inputEl.value : "";

//           // If the typed text resolves to exactly one product's SKU,
//           // send the browser straight to /search?q=<full SKU> instead
//           // of submitting the raw partial text — Shopify's native
//           // search matches the full SKU correctly, so this lands on a
//           // normal, fully-native results page.
//           // Only trust "exactly one SKU match" once the full index has
//           // loaded — otherwise we might redirect based on a partial,
//           // still-loading list and hide other real matches.
//           var skuMatch = null;
//           if (typedQuery && indexState.complete) {
//             var results = searchProducts(typedQuery, indexState.products, 50);
//             var skuMatches = results.filter(function (r) {
//               return r.matchedField === "sku";
//             });
//             if (skuMatches.length === 1) skuMatch = skuMatches[0].product.sku;
//           }

//           if (skuMatch && normalise(skuMatch) !== normalise(typedQuery)) {
//             window.location.href = "/search?q=" + encodeURIComponent(skuMatch);
//           } else if (typeof form.requestSubmit === "function") {
//             form.requestSubmit();
//           } else {
//             form.submit();
//           }
//         }
//         return;
//       }

//       if (
//         sharedContainer &&
//         !sharedContainer.hidden &&
//         target !== sharedContainer &&
//         !sharedContainer.contains(target) &&
//         !(target && target.classList && target.classList.contains("js-search-input"))
//       ) {
//         sharedContainer.hidden = true;
//       }
//     });

//     // Enter / form submit: intentionally left as the theme's native/
//     // default behaviour (not intercepted). Only the typing dropdown
//     // above is custom.
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }
// })();


(function () {
  "use strict";

  var FEED_URL = "/pages/search-index";
  var MIN_QUERY_LENGTH = 2;
  var MAX_RESULTS = 3;
  var DEBOUNCE_MS = 200;
  var COLLECTION_BATCH_SIZE = 5;

  var METAFIELD_LABELS = {
    sku: "SKU",
    instrumentation: "Instrumentation",
    composer: "Composer",
    arranger: "Arranger",
    contents_list: "Contents",
    isbn13: "ISBN13",
    upc: "UPC",
    supplier_code: "Supplier Code",
    label: "Label",
    tension: "Tension",
    colour: "Colour",
    size: "Size",
    made_in: "Made In"
  };
  var METAFIELD_KEYS = Object.keys(METAFIELD_LABELS);

  /* ---------------------------------------------------------------
   * Shared, progressively-growing product index for THIS page load.
   * ------------------------------------------------------------- */
  var indexState = {
    products: [], // grows as batches complete
    byId: {},
    complete: false,
    startedAt: null,
    listeners: [] // functions called after every batch update
  };

  function notifyProgress() {
    indexState.listeners.forEach(function (fn) {
      try {
        fn(indexState.products, indexState.complete);
      } catch (e) {
        /* ignore listener errors */
      }
    });
  }

  function onIndexProgress(fn) {
    indexState.listeners.push(fn);
    return function unsubscribe() {
      var i = indexState.listeners.indexOf(fn);
      if (i !== -1) indexState.listeners.splice(i, 1);
    };
  }

  function fetchJson(url) {
    var finalUrl = url + (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
    return fetch(finalUrl, { cache: "no-store" }).then(function (res) {
      if (!res.ok) throw new Error("Fetch failed: " + res.status + " for " + url);
      return res.json();
    });
  }

  function fetchAllCollectionHandles() {
    return fetchJson(FEED_URL + "?page=1").then(function (first) {
      var handles = (first.collections || []).slice();
      var totalPages = first.pages || 1;
      if (totalPages <= 1) return handles;

      var pagePromises = [];
      for (var p = 2; p <= totalPages; p++) {
        pagePromises.push(fetchJson(FEED_URL + "?page=" + p));
      }
      return Promise.all(pagePromises).then(function (rest) {
        rest.forEach(function (pageData) {
          handles = handles.concat(pageData.collections || []);
        });
        return handles;
      });
    });
  }

  var buildPromise = null;

  // Phase 1: fetch just page 1 of every collection (fast, lightweight).
  // This alone gives broad coverage quickly, including the first 250
  // products of even the largest collection. Phase 2 then fills in any
  // remaining pages, processing smaller leftovers first and the
  // biggest collection's remaining pages last, so early progress
  // updates aren't blocked waiting on the whole catalog.
  function startBuildingIndex() {
    if (buildPromise) return buildPromise;

    indexState.startedAt = Date.now();
    console.log("[CMS] building product index (two-phase, progressive)...");

    buildPromise = (async function () {
      try {
        var handles = await fetchAllCollectionHandles();
        console.log("[CMS] found", handles.length, "collections");

        function addProducts(products) {
          products.forEach(function (p) {
            if (!indexState.byId[p.id]) {
              indexState.byId[p.id] = p;
              indexState.products.push(p);
            }
          });
        }

        // ---- Phase 1: page 1 of every collection ----
        var needsMore = []; // { handle, pages }
        for (var i = 0; i < handles.length; i += COLLECTION_BATCH_SIZE) {
          var batch = handles.slice(i, i + COLLECTION_BATCH_SIZE);
          var batchResults = await Promise.all(
            batch.map(function (handle) {
              var base =
                "/collections/" +
                encodeURIComponent(handle) +
                "?view=feed&sort_by=title-ascending";
              return fetchJson(base + "&page=1")
                .then(function (data) {
                  return { handle: handle, data: data };
                })
                .catch(function (err) {
                  console.error("[CMS] failed fetching", handle, "page 1", err);
                  return null;
                });
            })
          );

          batchResults.forEach(function (result) {
            if (!result) return;
            addProducts(result.data.products || []);
            var totalPages = result.data.pages || 1;
            if (totalPages > 1) {
              needsMore.push({ handle: result.handle, pages: totalPages });
            }
          });

          notifyProgress(); // fast, broad progress after each small batch
        }

        console.log(
          "[CMS] phase 1 done:",
          indexState.products.length,
          "products from page-1 of every collection.",
          needsMore.length,
          "collections have more pages."
        );

        // ---- Phase 2: remaining pages, smallest leftovers first ----
        needsMore.sort(function (a, b) {
          return a.pages - b.pages;
        });

        for (var j = 0; j < needsMore.length; j++) {
          var entry = needsMore[j];
          var base2 =
            "/collections/" +
            encodeURIComponent(entry.handle) +
            "?view=feed&sort_by=title-ascending";

          var remainingPagePromises = [];
          for (var p = 2; p <= entry.pages; p++) {
            remainingPagePromises.push(fetchJson(base2 + "&page=" + p));
          }

          try {
            var pagesData = await Promise.all(remainingPagePromises);
            pagesData.forEach(function (pageData) {
              addProducts(pageData.products || []);
            });
          } catch (err) {
            console.error("[CMS] failed fetching remaining pages for", entry.handle, err);
          }

          notifyProgress(); // update after each collection's remaining pages finish
        }

        indexState.complete = true;
        var seconds = ((Date.now() - indexState.startedAt) / 1000).toFixed(1);
        console.log(
          "[CMS] index complete:",
          indexState.products.length,
          "products in",
          seconds + "s"
        );
        notifyProgress();
      } catch (err) {
        console.error("[CMS] building index FAILED:", err);
      }
    })();

    return buildPromise;
  }

  function normalise(str) {
    return (str || "").toString().toLowerCase().trim();
  }

  function alnumOnly(str) {
    return normalise(str).replace(/[^a-z0-9]/g, "");
  }

  function matchProduct(product, q) {
    var title = normalise(product.title);
    if (title.indexOf(q) !== -1) {
      return { field: null, score: title.indexOf(q) === 0 ? 100 : 80 };
    }

    if (product.sku) {
      var skuNorm = alnumOnly(product.sku);
      var qNorm = alnumOnly(q);
      if (qNorm && skuNorm.indexOf(qNorm) !== -1) {
        return { field: "sku", score: 90 };
      }
    }

    for (var i = 0; i < METAFIELD_KEYS.length; i++) {
      var key = METAFIELD_KEYS[i];
      if (key === "sku") continue;
      var val = normalise(product[key]);
      if (val && val.indexOf(q) !== -1) {
        return { field: key, score: 60 };
      }
    }
    return null;
  }

  function searchProducts(query, products, limit) {
    var q = normalise(query);
    if (q.length < MIN_QUERY_LENGTH) return [];

    var results = [];
    for (var i = 0; i < products.length; i++) {
      var match = matchProduct(products[i], q);
      if (match) {
        results.push({ product: products[i], matchedField: match.field, score: match.score });
      }
    }

    results.sort(function (a, b) {
      return b.score - a.score;
    });

    return results.slice(0, limit || MAX_RESULTS);
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function renderDropdown(container, results, query, stillLoading) {
    if (!results.length) {
      if (stillLoading) {
        container.innerHTML =
          '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
      } else {
        container.innerHTML =
          '<div class="cms-no-results">No results for &ldquo;' +
          escapeHtml(query) +
          "&rdquo;</div>" +
          '<button type="button" class="cms-view-all-btn">View all results</button>';
      }
      container.hidden = false;
      return;
    }

    var html = '<ul class="cms-results-list" role="listbox">';
    results.forEach(function (r) {
      var p = r.product;
      var matchLine = "";
      if (r.matchedField) {
        var label = METAFIELD_LABELS[r.matchedField] || r.matchedField;
        matchLine =
          '<span class="cms-result-match">' +
          escapeHtml(label) +
          ": " +
          escapeHtml(p[r.matchedField]) +
          "</span>";
      }
      html +=
        '<li class="cms-result-item" role="option">' +
        '<a href="' +
        escapeHtml(p.url) +
        '" class="cms-result-link">' +
        (p.image
          ? '<img class="cms-result-image" src="' +
            escapeHtml(p.image) +
            '" alt="" loading="lazy" width="48" height="48">'
          : '<span class="cms-result-image cms-result-image--empty"></span>') +
        '<span class="cms-result-text">' +
        '<span class="cms-result-title">' +
        escapeHtml(p.title) +
        "</span>" +
        matchLine +
        "</span>" +
        "</a>" +
        "</li>";
    });
    html += "</ul>";

    html += '<button type="button" class="cms-view-all-btn">View all results</button>';

    container.innerHTML = html;
    container.hidden = false;
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  var sharedContainer = null;

  function ensureContainer(input) {
    if (!sharedContainer) {
      sharedContainer = document.createElement("div");
      sharedContainer.id = "cms-metafield-results-shared";
      sharedContainer.className = "cms-metafield-results";
      sharedContainer.hidden = true;
    }
    var form = input.closest("form");
    var anchor = form || input;
    if (sharedContainer.previousElementSibling !== anchor) {
      anchor.insertAdjacentElement("afterend", sharedContainer);
    }
    return sharedContainer;
  }

  var activeUnsubscribe = null;

  function runDropdownSearch(input, container) {
    var query = input.value;

    if (activeUnsubscribe) {
      activeUnsubscribe();
      activeUnsubscribe = null;
    }

    if (normalise(query).length < MIN_QUERY_LENGTH) {
      container.hidden = true;
      container.innerHTML = "";
      return;
    }

    // Show a loading state immediately.
    container.innerHTML =
      '<div class="cms-loading"><span class="cms-spinner"></span>Searching&hellip;</div>';
    container.hidden = false;

    startBuildingIndex();

    function renderNow() {
      // Always read the CURRENT input value, in case the user kept
      // typing while a batch was loading — avoids showing stale results.
      var currentQuery = input.value;
      if (normalise(currentQuery).length < MIN_QUERY_LENGTH) return;
      var results = searchProducts(currentQuery, indexState.products, MAX_RESULTS);
      renderDropdown(container, results, currentQuery, !indexState.complete);
    }

    renderNow(); // render with whatever's loaded so far, immediately
    activeUnsubscribe = onIndexProgress(renderNow); // keep updating as more loads
  }

  var handleInputDebounced = debounce(function (input, container) {
    runDropdownSearch(input, container);
  }, DEBOUNCE_MS);

  /* ---------------------------------------------------------------
   * Inject extra matches (metafields/SKU) directly into the native
   * /search results grid (<ul class="grid"> inside #filter-results),
   * as real <li> items using the theme's own card classes — so they
   * look like normal results, not a separate section.
   *
   * Two scenarios are handled:
   *   1. Theme found >=1 native result: #filter-results and its
   *      ul.grid already exist — we just append into that same grid.
   *   2. Theme found 0 native results: many themes render NO
   *      #filter-results container at all in this case, just a
   *      "No results found" message. We locate that message and
   *      build our own grid directly after it, then remove the
   *      message once we have real matches to show — so the page
   *      never shows both "No results found" and actual results.
   * ------------------------------------------------------------- */
  function findNoResultsElement() {
    var candidates = document.querySelectorAll("body *");
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      // Match on the smallest element containing the phrase, so we
      // don't grab a huge wrapper (e.g. <body> or <main>) by mistake.
      if (el.children.length === 0 && /no results found/i.test(el.textContent || "")) {
        return el;
      }
    }
    return null;
  }

  // For OUR OWN injected grid (used only when native search found 0
  // results and no real grid exists yet), we set layout via inline
  // styles rather than the theme's Tailwind utility classes. Utility
  // classes like "grid-cols-1 sm:grid-cols-3" only reliably apply when
  // the THEME'S OWN Liquid server-renders them (as with a real 2-result
  // page) — on an element we create purely in JS, this combination was
  // found NOT to take effect (cards collapsed into a broken single
  // column). Inline styles have no such dependency and always work.
  // NOTE: layout is controlled entirely by the .custome_design_grid
  // CSS class (added by the client in their theme's stylesheet), not
  // by inline styles here. Inline styles always win over CSS classes
  // in specificity, so setting them here would silently override any
  // custom CSS written for that class — this function intentionally
  // does nothing now; it's kept only so existing call sites don't
  // need to change.
  function applyFallbackGridStyles(ul) {
    // no-op — layout comes from the .custome_design_grid class instead
  }

  // Resolved ONCE per page load and reused for every progressive
  // re-render (as more of the product index loads), so we never end up
  // creating a second grid element in a different spot mid-way through
  // — which previously caused a stray duplicate card to appear outside
  // the real results area.
  var targetGridEl = null;

  // When native search finds 0 results, this theme skips rendering the
  // left filter sidebar (.main-products-grid__filters) entirely, since
  // there's nothing real to filter. That shifts our injected grid to
  // the full page width instead of sitting next to a sidebar like a
  // normal results page. We add an EMPTY placeholder div using the
  // theme's own sidebar class name, so its existing CSS (width,
  // padding, etc.) applies automatically — matching the two-column
  // layout visually, with no functional filters inside it.
  function ensureFilterPlaceholder(resultsEl) {
    var parent = resultsEl.parentElement;
    if (!parent) return;
    if (parent.querySelector(".main-products-grid__filters")) return; // real filters already present

    var placeholder = document.createElement("div");
    placeholder.className = "main-products-grid__filters cms-filter-placeholder";
    // The real sidebar's width comes from its inner facet-filters
    // content, not from this wrapper div's own CSS — so an EMPTY
    // version of it collapses to zero width and reserves no space.
    // Set an explicit width/flex-basis so the two-column layout still
    // appears, matching the sidebar's typical visual width.
    placeholder.style.width = "220px";
    placeholder.style.minWidth = "220px";
    placeholder.style.flex = "0 0 220px";
    parent.insertBefore(placeholder, resultsEl);
  }

  function findResultsGrid() {
    if (targetGridEl && document.body.contains(targetGridEl)) return targetGridEl;

    var scope = document.getElementById("filter-results");
    if (scope) {
      ensureFilterPlaceholder(scope);

      var existing = scope.querySelector("ul.grid, ul[role='list']");
      if (existing) {
        existing.classList.add("custome_design_grid");
        // Only force our layout styles when this grid is EMPTY (0
        // native results) — if the theme already put real native
        // cards in here (e.g. a working full-SKU search), its own
        // classes are already laying it out correctly; don't touch it.
        if (existing.children.length === 0) {
          applyFallbackGridStyles(existing);
        }
        targetGridEl = existing;
        return targetGridEl;
      }

      // #filter-results exists but has no grid yet (0 native results
      // on this theme) — build one with guaranteed inline grid styles.
      var ul = document.createElement("ul");
      ul.setAttribute("role", "list");
      ul.classList.add("custome_design_grid");
      applyFallbackGridStyles(ul);
      scope.appendChild(ul);
      targetGridEl = ul;
      return targetGridEl;
    }

    // Fallback: theme renders nothing resembling #filter-results at
    // all when native search returns 0 results — just a "No results
    // found" message. Build the grid right after that message.
    var existingFallback = document.getElementById("cms-fallback-grid");
    if (existingFallback) {
      existingFallback.classList.add("custome_design_grid");
      targetGridEl = existingFallback;
      return targetGridEl;
    }

    var noResultsEl = findNoResultsElement();
    if (!noResultsEl) return null;

    var ul2 = document.createElement("ul");
    ul2.id = "cms-fallback-grid";
    ul2.setAttribute("role", "list");
    ul2.classList.add("custome_design_grid");
    applyFallbackGridStyles(ul2);
    noResultsEl.insertAdjacentElement("afterend", ul2);
    targetGridEl = ul2;
    return targetGridEl;
  }

  // Exact card markup this store's theme renders for each product in
  // search results — verified against the same real page HTML above
  // (a <li class="js-pagination-result"> containing a <product-card>
  // with card__media, card__info-container, card__title, price, etc.)
  var PLACEHOLDER_SVG =
    '<svg class="media__placeholder img-fit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">' +
    '<path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>' +
    "</svg>";

  function buildCardListItem(product, matchedField) {
    var li = document.createElement("li");
    li.className = "js-pagination-result cms-extra-result";

    var mediaContent = product.image
      ? '<img class="img-fit" src="' +
        escapeHtml(product.image) +
        '" alt="" loading="lazy" width="300" height="300">'
      : PLACEHOLDER_SVG;

    var matchLine = "";
    if (matchedField) {
      var label = METAFIELD_LABELS[matchedField] || matchedField;
      matchLine =
        '<p class="cms-extra-match mb-0 text-sm text-theme-light">' +
        escapeHtml(label) +
        ": " +
        escapeHtml(product[matchedField]) +
        "</p>";
    }

    li.innerHTML =
      '<product-card class="card card--product h-full card--no-lines relative flex">' +
      '<div class="card__media relative">' +
      '<a href="' +
      escapeHtml(product.url) +
      '" aria-label="' +
      escapeHtml(product.title || "") +
      '" class="media block relative js-prod-link" style="padding-top: 100%;" tabindex="-1">' +
      mediaContent +
      "</a>" +
      "</div>" +
      '<div class="card__info-container flex flex-col flex-auto relative">' +
      '<div class="card__info w-full">' +
      '<div class="card__info-inner flex flex-col h-full w-full">' +
      (product.vendor
        ? '<p class="card__vendor mb-0 text-sm text-theme-light">' + escapeHtml(product.vendor) + "</p>"
        : "") +
      '<p class="card__title font-bold mt-1 mb-0">' +
      '<a href="' +
      escapeHtml(product.url) +
      '" class="card-link text-current js-prod-link">' +
      escapeHtml(product.title || "") +
      "</a>" +
      "</p>" +
      matchLine +
      '<div class="flex grow items-end">' +
      '<div class="price price--bottom">' +
      '<div class="price__default">' +
      '<strong class="price__current">' +
      (product.price ? escapeHtml(product.price) : "") +
      "</strong>" +
      '<s class="price__was"></s>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</product-card>";

    return li;
  }

  function toPathname(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url;
    }
  }

  function getNativeResultIds(grid) {
    // Native cards on this theme carry no data-product-id, so dedupe
    // by the product URL path instead — reliably present on both
    // native and our own injected cards.
    var paths = {};
    grid.querySelectorAll("a[href]").forEach(function (a) {
      var path = toPathname(a.getAttribute("href"));
      if (path) paths[path] = true;
    });
    return paths;
  }

  function renderNativeExtraResults(results) {
    var grid = findResultsGrid();
    if (!grid) return; // no grid and no "No results found" message found — nothing to do

    // Remove any previously-injected items before re-adding (progressive
    // updates re-render the full result set each time).
    grid.querySelectorAll(".cms-extra-result").forEach(function (el) {
      el.remove();
    });

    // Avoid duplicating a product that the theme's own native search
    // already placed in the grid (relevant when native results > 0).
    var nativePaths = getNativeResultIds(grid);

    var addedAny = false;
    results.forEach(function (r) {
      if (nativePaths[toPathname(r.product.url)]) return; // already shown natively, skip
      grid.appendChild(buildCardListItem(r.product, r.matchedField));
      addedAny = true;
    });

    // We found real matches to show, so any "No results found" message
    // on the page (whether it's the one above our own fallback grid, or
    // the theme's top-of-page message shown alongside a real-but-empty
    // native grid) is now inaccurate — remove it.
    if (addedAny) {
      var noResultsEl = findNoResultsElement();
      if (noResultsEl) noResultsEl.remove();
    }
  }

  /**
   * If the typed query matches EXACTLY ONE product's SKU (title
   * matches don't count here — only a SKU/metafield substring match),
   * redirect the browser to /search?q=<that product's full SKU>. This
   * hands the query back to Shopify's OWN native search, which already
   * matches full SKUs correctly — so the resulting page is a normal,
   * fully-native results page (correct URL, correct markup, no custom
   * grid needed).
   *
   * If MULTIPLE products match (ambiguous — redirecting would hide
   * the others), this does nothing and the caller falls back to
   * injecting all matches into a grid instead.
   *
   * Returns true if a redirect was triggered (caller should stop).
   */
  function attemptSkuRedirect(query) {
    var q = normalise(query);
    var results = searchProducts(query, indexState.products, 50);
    var skuMatches = results.filter(function (r) {
      return r.matchedField === "sku";
    });

    if (skuMatches.length !== 1) return false; // none, or ambiguous — skip

    var fullSku = skuMatches[0].product.sku;
    if (!fullSku || normalise(fullSku) === q) return false; // already this exact value — avoid redirect loop

    var params = new URLSearchParams(window.location.search);
    params.set("q", fullSku);
    var newUrl = window.location.pathname + "?" + params.toString();
    console.log("[CMS] redirecting partial SKU query to full SKU:", query, "->", fullSku);
    window.location.replace(newUrl);
    return true;
  }

  function initNativeSearchAugmentation() {
    if (window.location.pathname.indexOf("/search") !== 0) return;

    var params = new URLSearchParams(window.location.search);
    var query = params.get("q") || "";
    if (normalise(query).length < MIN_QUERY_LENGTH) return;

    var scope = document.getElementById("filter-results");
    var nativeGrid = scope && scope.querySelector("ul.grid");
    var nativeHasResults = !!(nativeGrid && nativeGrid.children.length > 0);

    var redirected = false;

    startBuildingIndex();

    function tryRedirectOrRender() {
      if (redirected) return;

      // IMPORTANT: only decide to redirect once the FULL product index
      // has finished loading. Deciding earlier (mid-way through the
      // progressive load) risks seeing only 1 match right now when 2
      // more matching products haven't been indexed yet — which would
      // wrongly redirect away before the other matches are found.
      if (!nativeHasResults && indexState.complete && attemptSkuRedirect(query)) {
        redirected = true;
        return;
      }

      // Show/merge whatever matches we have so far — for EVERY query,
      // not just ones where native search found zero results. This
      // fills in any extra metafield/SKU matches Shopify's own search
      // missed, right into the existing results grid, deduped against
      // whatever native already found.
      var results = searchProducts(query, indexState.products, 10);
      renderNativeExtraResults(results);
    }

    onIndexProgress(tryRedirectOrRender);
    tryRedirectOrRender();
  }

  function getRealTarget(e) {
    if (typeof e.composedPath === "function") {
      var path = e.composedPath();
      if (path && path.length) return path[0];
    }
    return e.target;
  }

  function init() {
    console.log("[CMS] custom-metafield-search.js initialised");

    initNativeSearchAugmentation();

    document.addEventListener(
      "focus",
      function (e) {
        var target = getRealTarget(e);
        if (target && target.classList && target.classList.contains("js-search-input")) {
          startBuildingIndex(); // warm up the index as soon as the box is focused
        }
      },
      true
    );

    document.addEventListener("input", function (e) {
      var input = getRealTarget(e);
      if (!input || !input.classList || !input.classList.contains("js-search-input")) return;
      var container = ensureContainer(input);
      handleInputDebounced(input, container);
    });

    document.addEventListener("click", function (e) {
      var target = getRealTarget(e);

      if (target && target.classList && target.classList.contains("cms-view-all-btn")) {
        var form = sharedContainer && sharedContainer.previousElementSibling;
        if (form && form.tagName === "FORM") {
          var inputEl =
            form.querySelector(".js-search-input") || form.querySelector('input[name="q"]');
          var typedQuery = inputEl ? inputEl.value : "";

          // If the typed text resolves to exactly one product's SKU,
          // send the browser straight to /search?q=<full SKU> instead
          // of submitting the raw partial text — Shopify's native
          // search matches the full SKU correctly, so this lands on a
          // normal, fully-native results page.
          // Only trust "exactly one SKU match" once the full index has
          // loaded — otherwise we might redirect based on a partial,
          // still-loading list and hide other real matches.
          var skuMatch = null;
          if (typedQuery && indexState.complete) {
            var results = searchProducts(typedQuery, indexState.products, 50);
            var skuMatches = results.filter(function (r) {
              return r.matchedField === "sku";
            });
            if (skuMatches.length === 1) skuMatch = skuMatches[0].product.sku;
          }

          if (skuMatch && normalise(skuMatch) !== normalise(typedQuery)) {
            window.location.href = "/search?q=" + encodeURIComponent(skuMatch);
          } else if (typeof form.requestSubmit === "function") {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
        return;
      }

      if (
        sharedContainer &&
        !sharedContainer.hidden &&
        target !== sharedContainer &&
        !sharedContainer.contains(target) &&
        !(target && target.classList && target.classList.contains("js-search-input"))
      ) {
        sharedContainer.hidden = true;
      }
    });

    // Enter / form submit: intentionally left as the theme's native/
    // default behaviour (not intercepted). Only the typing dropdown
    // above is custom.
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();